// //ZpDataService backup of my changes

import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { v4 as uuid } from "uuid";
import plantree from "../../assets/data/plan-tree.json";
import { FormTemplateDataEntryService } from "./form-template-data-entry.service";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { UserInfoService } from "./user-info.service";
import { SideNavBarVisibilityService } from "./side-nav-bar-visibility.service";
import { NotificationService } from "./notification.service";
import { ZPNotification } from "../models/zpnotification";
import { NotificationType } from "../models/notification-type.enum";
import { isArray } from "util";
import { PreviousUrlService } from "./previous-url.service";
import { CurrencyConvertService } from "./currency-convert.service";
import { IUser } from "../models/user.model";

@Injectable({
  providedIn: "root",
})
export class ZpDataService {
  private messageSource = new BehaviorSubject("");
  private apiUrl: string = window["ZP_CONFIG"].apiUrl; // "http://localhost:5858" //"http://zp-dev.pivotalapps.com:5858";
  public chargeBeeSite: string = window["ZP_CONFIG"].chargeBeeSite; //"zenplans-test";
  public headers: HttpHeaders;
  private token: string = undefined;
  private redirectUrlAfterLogin: string;
  private redirectParamsAfterLogin: {};
  private refCode: string;
  private lastErrorMessage: string;
  private _cache;
  currentMessage: Observable<string> = this.messageSource.asObservable();
  private refCodeInfo: {
    userType?: string;
    professionalLicense?: string;
    funded?: boolean;
    hideSponsor?: boolean;
    directInvoice?: boolean;
    company?: string;
    logo?: string;
    firstName?: string;
    lastName?: string;
  };
  public passwordError: boolean;
  public subscriptionNotValid = false;
  public initialized: boolean;
  public isOwnerSelected: boolean;
  // public selectedOwners: any;
  public ownersHashmap: any;
  public ownersSelectedHashmap: {} = {}

  constructor(
    private formTemplateService: FormTemplateDataEntryService,
    private httpClient: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private userInfo: UserInfoService,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private notificationService: NotificationService,
    private previousUrlService: PreviousUrlService,
    private currencyConvert: CurrencyConvertService
  ) {
    this.emptyCache();
    //let allData = localStorage.getItem("zenplansData");
    this.token = localStorage.getItem("token") || undefined;
    //if (allData) { this.messageSource.next(allData); }
    this.headers = new HttpHeaders();
    this.initialized = false;

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (!this.initialized) {
          this.initialized = true;
          if (
            this.loggedIn() &&
            event.url &&
            event.url.indexOf("sign-up") >= 0
          ) {
            //this.logout(true);
            //this.alertMessage({ message: "User Already Logged In", additionalInfo: "Please log-out before attempting to create a new user, otherwise there may be unpredictable side-effects." })
          }
          if (!this.loggedIn()) {
            if (event.url) {
              if (
                event.url.indexOf("log-in") < 0 &&
                event.url.indexOf("sign-up") < 0 &&
                event.url.indexOf("reset") < 0
              ) {
                this.router.navigate(["/log-in"]);
              }
            }
          } else {
            this.attemptSessionRestore(true)
              .then(() => { })
              .catch();
          }
        } else {
          // refresh session token.
          if (
            this.loggedIn() &&
            event.url &&
            event.url.indexOf("sign-up") >= 0
          ) {
            //this.logout(true);
            //this.alertMessage({ message: "User Already Logged In", additionalInfo: "Please log-out before attempting to create a new user, otherwise there may be unpredictable side-effects." },NotificationType.Error,false)
          }
          if(this.loggedIn()){ //don't try to get a token if we aren't logged in already.
            this.refreshToken();
          }
        }
      }
    });
  }

  getApiUrl() {
    return this.apiUrl;
  }
  getToken() {
    return this.token;
  }
  async createNewRefCode(refCode, userType, professionalLicense, funded) {
    let params = {};
    if (refCode) {
      params["code"] = refCode;
    }
    if (userType) {
      params["userType"] = userType;
    }
    if (professionalLicense) {
      params["professionalLicense"] = professionalLicense;
    }
    params["funded"] = funded == true;

    let refCodeObj = await this.retrieveData(
      "post",
      "/api/referralCodeCreate",
      params
    );

    return refCodeObj;
  }

  async setRefCode(refCode) {
    this.refCode = refCode;
    await this.retrieveValidRefCode(this.refCode);
  }

  getRefCodeInfo() {
    return this.refCodeInfo;
  }

  getRefCode() {
    return this.refCode;
  }

  async logout(dontgoanywhere = false) {
    this.token = undefined;
    await localStorage.removeItem("token");
    await sessionStorage.clear();
    this.emptyCache();
    if (!dontgoanywhere) {
      this.router.navigate(["/log-in"]);
    }
  }

  loggedIn() {
    return this.token != undefined;
  }

  userHasNoPlan() {
    if (
      this._cache &&
      this._cache.plan &&
      this._cache.plan["/api/plan"] &&
      Object.keys(this._cache.plan["/api/plan"]).length === 0
    ) {
      return false;
    }
    return true;
  }

  async attemptSessionRestore(doNotRedirect?: boolean) {
    if (this.loggedIn()) {
      let myUser = await this.getUser();
      this.userInfo.changeMessage(JSON.stringify(myUser));
      // await this.connectToMySharedPlans(myUser);
      let mySharedPlans = await this.getMySharedPlans(myUser["Id"]);
      this.revalidateCache().then(() => {
        this.changeMessage(JSON.stringify(this._cache.plan));
        if (mySharedPlans && mySharedPlans.length > 0 && this.userHasNoPlan()) {
          this.sideNavBarVisibilityService.changeMessage("top");
        } else {
          this.sideNavBarVisibilityService.changeMessage("bottom");
        }
      });
      let urlParams = this.redirectParams();
      let url = this.redirectUrl();
      if (!doNotRedirect) {
        if (url) {
          this.router.navigate([url, urlParams]);
        } else {
          if (!mySharedPlans || mySharedPlans.length == 0) {
            this.sideNavBarVisibilityService.changeMessage("");
            this.router.navigate(["/home"]);
          } else {
            this.router.navigate(["/delegate-home-page"]);
            this.sideNavBarVisibilityService.changeMessage("none");
          }
        }
      }
    } else {
      this.alertMessage({
        message: "No session",
        additionalInfo: "Please log-in in to access this page.",
      });
      this.router.navigate(["/log-in"]);
    }
  }

  redirectParams() {
    return this.redirectParamsAfterLogin;
  }

  redirectUrl(url?: string, params?: {}) {
    if (!url) {
      url = this.redirectUrlAfterLogin;
      this.redirectUrlAfterLogin = undefined;
      this.redirectParamsAfterLogin = undefined;
      return url;
    } else {
      this.redirectUrlAfterLogin = url;
      this.redirectParamsAfterLogin = params;
    }
  }

  alertMessage(message, type?: NotificationType, timeout?: boolean) {
    let self = this;
    if (this.lastErrorMessage && this.lastErrorMessage === message) {
      return;
    }
    this.lastErrorMessage = message;
    //alert(message);
    this.notificationService.changeMessage(
      new ZPNotification(
        message.message ? message.message : message,
        undefined,
        message.title ? message.title : undefined,
        message.additionalInfo ? message.additionalInfo : undefined,
        message.type ? message.type : type ? type : undefined
      )
    );

    if (timeout == true) {
      setTimeout(() => {
        if (self.lastErrorMessage === message) {
          self.lastErrorMessage = undefined;
        }
      }, 3000);
    }
  }

  changeMessage(message: string) {
    this.messageSource.next(message);
  }

  async getMessage() {
    return await this.currentMessage.toPromise();
  }

  getMessageNotAsync() {
    return this.currentMessage;
  }

  async updateSubscriptionStatus(completeResponse) {
    // console.log(completeResponse);
    let data = completeResponse; //.body;
    if (data && data.success === false && data.subscription === false) {
      //this.alertMessage("No valid subscription.");
      let user = await this.getUser();
      if (user && user.subscriptionId) {
        this.router.navigate(["/payment-subscription"]);
      } else {
        if (
          user["userType"] === "professional" ||
          user["userType"] === "professionalManager"
        ) {
          this.router.navigate(["/payment-choose-licenses"]);
        } else {
          this.router.navigate(["/payment-choose-plan"]);
        }
      }
    }
    // else {
    //   console.log("HEADERS:"+JSON.stringify(completeResponse.headers) );
    //   if(completeResponse.headers && completeResponse.headers.updatedToken){
    //     this.token = completeResponse.headers.updatedToken;
    //     localStorage.setItem('token', this.token);
    //   }
    //   //do nothing and carry on.
    // }
  }

  identifyAndHandleHTTPErrorStates(err) {
    let self = this;
    switch (err.status) {
      case 408:
        this.alertMessage({
          message: "Session Expired",
          additionalInfo: "Your session has expired please log in again.",
        });
        setTimeout(() => {
          self.logout();
        }, 100);
        break;
      case 403:
        this.alertMessage({
          message: "Sorry",
          additionalInfo: "You do not have the right permission for this.",
          type: NotificationType.Warning,
        });
        break;
      case 402:
        this.subscriptionNotValid = true;
        //this.alertMessage({message:"Sorry",additionalInfo: "Your subscription has expired. Please re-subscribe to continue.",type:NotificationType.Warning});
        break;
      case 406:
        this.alertMessage({
          message: "Sorry",
          additionalInfo:
            "Your identity could not be confirmed. Please log in again.",
          type: NotificationType.Warning,
        });
        this.logout();
        break;
    }
  }

  emptyCache() {
    this._cache = { plan: {}, shared: {} };
  }

  async revalidateCache(clientId?, response?) {
    console.debug("revalidateCache " + (clientId ? "(" + clientId + ")" : ""));
    if (!this.token) {
      return;
    } else {
      if (response && response.zptoken) {
        this.token = response.zptoken;
      }
    }
    this._cache = { plan: {}, shared: {} };
    let data;
    this.userInfo.currentMessage.toPromise().then(async (myUserString) => {
      try {
        let myUser = JSON.parse(myUserString);
        if (myUser && myUser.Id) {
          this._cache.shared[myUser.Id] = {};
          let params = new HttpParams().set("clientId", clientId);
          try {
            this._cache.shared[clientId] = {};
          } catch (err) { }
          data = await this.retrieveData("get", "/api/plan", params, true);
          if (data) {
            this.cacheData("/api/plan", params, data);
          }
        }
      } catch (err) { }
    });
    data = await this.retrieveData("get", "/api/plan", undefined, true);
    if (data) {
      this.cacheData("/api/plan", undefined, data);
    }
  }

  //
  //   let data;
  //   let params = new HttpParams();
  //   this.userInfo.currentMessage.toPromise().then((myUserString)=>{
  //     try {
  //       let myUser = JSON.parse(myUserString);
  //       if (myUser && myUser.Id) {
  //         this._cache.shared[myUser.Id] = {};
  //       }
  //     }catch(err){
  //
  //     }
  //   });
  //   if(!clientId){
  //     try{
  //       this._cache.plan = {};
  //     }catch(err){}
  //     data = await this.retrieveData("get","/api/plan", undefined,true);
  //   }else{
  //     params = params.set("clientId",clientId);
  //     try{
  //       this._cache.shared[clientId] = {};
  //     }catch(err){}
  //     data = await this.retrieveData("get","/api/plan",params, true);
  //   }
  //   if(data){
  //     this.cacheData("api/plan",params,data);
  //   }
  // }

  retrieveDataFromCache(url, params) {
    console.debug(
      "retrieveDataFromCache " + url + (params ? "?" + params.toString() : "")
    );

    if (!this.token) {
      return undefined;
    }
    let previousQuery = this.cacheRetrieve(url, params);
    if (previousQuery) {
      console.debug("successfully found previous query:"+url + (params ? "?" + params.toString() : ""));
      return previousQuery;
    } else {
      //attempt plan parsing.
      let planCache = this._cache.plan["/api/plan"];
      let clientId = params ? params.get("clientId") : undefined;
      let section = params ? params.get("section") : undefined;
      let id = params ? params.get("Id") : undefined;
      if (clientId) {
        planCache = this._cache.shared[clientId]
          ? this._cache.shared[clientId]["/api/plan"]
          : undefined;
      }
      if (planCache) {
        if (url === "/api/item" && planCache && section) {
          let result = planCache[section];
          if (result && id) {
            result = result.find((item) => item.Id === id);
          }

          return result;
        }
      }
    }
    return;
  }

  cacheData(url, params, data) {
    console.debug(
      "cacheData " +
      url +
      (params ? "?" + params.toString() : "") +
      (data ? "" : " data === undefined")
    );
    if (data != {} && !data) {
      return;
    }
    if (!this._cache) {
      this._cache = { plan: {}, shared: {} };
    }
    if (params && params.get("clientId")) {
      if (!this._cache.shared[params.get("clientId")]) {
        this._cache.shared[params.get("clientId")] = {};
      }
      this._cache.shared[params.get("clientId")][url + params.toString()] =
        data;
    } else {
      let paramsString = params ? params.toString() : "";
      this._cache.plan[url + paramsString] = data;
    }
  }

  cacheRetrieve(url, params) {
    console.debug(
      "cacheRetrieve " + url + (params ? "?" + params.toString() : "")
    );

    try {
      if (this._cache) {
        if (params.get("clientId")) {
          return this._cache.shared[params.get("clientId")][
            url + params.toString()
          ];
        } else {
          return this._cache.plan[url + params.toString()];
        }
      }
    } catch (err) {
      console.debug("cacheRetrieve error: " + err);
      return undefined;
    }
  }

  public async retrieveData(
    type: string = "get",
    url: string,
    params?,
    noCache?
  ) {
    // console.info("retrieveData " + type.toUpperCase() + " " + url + ((params) ? "?" + params.toString() : "") + ((noCache) ? " !no-cache" : ""));
    let data;
    let response;
    let options = this.token ? { headers: { Authorization: this.token } } : {};
    if (type == "get") {
      if (params) {
        options["params"] = params;
      }
      try {
        !noCache ? (data = this.retrieveDataFromCache(url, params)) : undefined; //save time by going to cache if at all possible.
        if (!data) {
          response = await this.httpClient
            .get(this.apiUrl + url, options)
            .toPromise();
          data = response; //.body;
          this.updateSubscriptionStatus(response);
          this.cacheData(url, params, data);
        } else {
          console.debug("CACHE retrieved and used! ");
          console.debug(data);
        }
      } catch (err) {
        this.identifyAndHandleHTTPErrorStates(err);
        console.log(err);
        return err.error;
      }
    } else {
      try {
        response = await this.httpClient
          .post(this.apiUrl + url, params, options)
          .toPromise();
        data = response; //.body;
        this.updateSubscriptionStatus(response);
        this.revalidateCache(params.clientId, response); //posts (almost) always change data so lets invalidate the cache
      } catch (err2) {
        this.identifyAndHandleHTTPErrorStates(err2);
        console.log(err2);
        if (url === "/api/cbcheckout") {
          alert(
            "Sorry, an error occurred, please log-in and try again, or contact support."
          );
          let cbInstance = window["Chargebee"].getInstance();
          if (cbInstance) {
            cbInstance.closeAll();
          }
          this.logout();
        }
        return err2.error;
      }
    }
    if (data && data.name === "TokenExpiredError") {
      this.token = undefined;
      localStorage.removeItem("token");
    }
    return data;
  }

  async getSection(sectionName, userId?) {
    var params;

    if (userId) {
      params = new HttpParams()
        .set("section", sectionName)
        .set("clientId", userId);
    } else {
      params = new HttpParams().set("section", sectionName);
    }
    return await this.retrieveData("get", "/api/item", params);
  }

  async getSectionItemNames(sectionName, userId?, itemType?) {
    let itemNames: string[] = [];

    if (itemType) {
      if (typeof sectionName === "string") {
        let params = new HttpParams().set("section", sectionName);
        if (userId) {
          params = params.set("clientId", userId);
        }
        let mySection = await this.retrieveData("get", "/api/item", params);
        mySection
          .filter((kk) => kk["itemType"] == itemType)
          .map((item) => {
            itemNames.push(item["itemName"]);
          });
      } else {
        //an array I hope
        for (let i = 0; i < sectionName.length; i++) {
          let params = new HttpParams().set("section", sectionName[i]);
          if (userId) {
            params = params.set("clientId", userId);
          }
          let mySection = await this.retrieveData("get", "/api/item", params);
          mySection
            .filter((kk) => kk["itemType"] == itemType)
            .map((item) => {
              itemNames.push(item["itemName"]);
            });
        }
      }
    } else {
      let params = new HttpParams().set("section", sectionName);
      if (userId) {
        params = params.set("clientId", userId);
      }
      let mySection = await this.retrieveData("get", "/api/item", params);
      mySection
        .filter((kk) => kk["itemType"] == itemType)
        .map((item) => {
          itemNames.push(item["itemName"]);
        });
    }

    return itemNames;
  }

  async getSectionItemIdsAndNames(sectionName, userId?, itemType?) {
    let itemIdsAndNames: [{}] = [{}];
    itemIdsAndNames.pop();
    let params = new HttpParams().set("section", sectionName);
    if (userId) {
      params = params.set("clientId", userId);
    }
    let mySection = await this.retrieveData("get", "/api/item", params);

    if (itemType) {
      //for getting all items with a specified itemType
      mySection
        .filter((kk) => kk["itemType"] == itemType)
        .map((item) => {
          itemIdsAndNames.push({ Id: item["Id"], itemName: item["itemName"] });
        });
    } else {
      //get all items in the section
      mySection.map((item) => {
        itemIdsAndNames.push({ Id: item["Id"], itemName: item["itemName"] });
      });
    }
    if (itemIdsAndNames.length) {
      return itemIdsAndNames;
    }
    return null;
  }

  async addItem(myItem, sectionName) {
    let item = JSON.parse(myItem);
    item.Id = item.Id || uuid();
    let referrer = this.previousUrlService.getPreviousUrl();
    if (sectionName === "users") {
      item.clientId = item.Id;
    }
    let data = await this.retrieveData("post", "/api/item", {
      item: item,
      section: sectionName,
    });
    if (data) {
      if (referrer == "/dynamicformdataentry/delegate_3_4") {
        this.alertMessage({
          message: "Delegate invited!",
          additionalInfo:
            "We've emailed them a link to create a Delegate Account. Once created, they can access your plan according to the permissions you gave them.",
        });
      } else {
        this.alertMessage({
          message: "Success!",
          additionalInfo:
            (myItem && myItem.itemName ? myItem.itemName : "Item") +
            " added to plan.",
        });
      }
      this.changeMessage(
        JSON.stringify(await this.retrieveData("get", "/api/plan"))
      );
      data.itemId = item.Id;
      return data;
    }

    return null;
  }

  async retrieveSharedPlanRefCode(refCode: string) {
    if (!refCode) {
      return;
    }
    let data = await this.retrieveData(
      "get",
      "/api/referralCode",
      new HttpParams().set("code", refCode)
    );
    return data;
  }

  async retrieveValidRefCode(refCode: string) {
    if (!refCode) {
      return;
    }
    let data = await this.retrieveData(
      "get",
      "/api/referralCode",
      new HttpParams().set("code", refCode)
    );
    if (data) {
      return (this.refCodeInfo = data);
    }
  }

  async addUser(myItem) {
    //this.addItem(myItem,"users");
    //return;
    let userSections: {}[] = [];
    let item;
    if (typeof myItem === "string") {
      item = JSON.parse(myItem);
    } else {
      item = myItem;
    }

    item["planUpdateLastReminder"] = new Date();
    for (let i = 0; i < plantree.length; i++) {
      let sections = plantree[i].sections;
      for (let j = 0; j < sections.length; j++) {
        let kk = { section: sections[j], complete: false };
        userSections.push(kk);
      }
    }
    item["sectionList"] = userSections;
    item.Id = uuid();
    item.clientId = item.Id;
    if (this.getRefCode()) {
      item.refCode = this.getRefCode();
    }
    let operation = await this.retrieveData("post", "/api/signup", {
      user: item,
    });
    if (operation && operation.success) {
      console.log("signup token: " + operation.zptoken);
      this.token = operation.zptoken;
      return item;
    } else {
      if (operation && operation.error) {
        if (operation.result.code === "GEMINI") {
          let result = confirm(
            "A user with that email address already exists within the system. Perhaps you meant to sign in?"
          );
          if (result) {
            this.router.navigate(["/sign-in"]);
          }
        } else {
          if (operation.result.code === "NOTINVITED") {
            alert("You have not been invited to sign up for this plan. You may be using the wrong email address. Please contact support@zenplans.co.uk");
          } else {
            alert(
              "There was a problem creating the user at this time. Please contact support@zenplans.co.uk"
            );
          }
        }
      } else {
        alert(
          "There was a problem creating the user at this time. Please contact support@zenplans.co.uk"
        );
      }
    }
  }

  async updateItem(myItem, sectionName, clientId?) {
    var data;
    let referrer = window.location.href;
    if (clientId) {
      data = await this.retrieveData("post", "/api/item", {
        item: myItem,
        section: sectionName,
        clientId: clientId,
      });
    } else {
      data = await this.retrieveData("post", "/api/item", {
        item: myItem,
        section: sectionName,
      });
    }

    if (data) {
      if (referrer.includes("dynamicedit/delegate-edit")) {
        this.alertMessage({
          message: "Success!",
          additionalInfo: " Delegate access updated.",
        });
      } else {
        this.alertMessage({
          message: "Success!",
          additionalInfo:
            (myItem && myItem.itemName ? myItem.itemName : "Item") +
            "  updated in plan.",
        });
      }
      this.changeMessage(
        JSON.stringify(await this.retrieveData("get", "/api/plan"))
      );
      return true;
    }
    return null;
  }

  async updateUser(myUser) {
    //the myUser object will contain only those fields that need to be updated, and the Id
    //for changing password, send OldPassword also
    //doesn't work for email change
    var data;
    let user = myUser;
    if (typeof user === "string") {
      try {
        user = JSON.parse(user);
      } catch (err) {
        console.log(
          "invalid myUser string -- can't be parsed into JSON object"
        );
      }
    }
    data = await this.retrieveData("post", "/api/user", { user: user });
    if (data.error) {
      console.log(data);
      this.passwordError = true;
      return null;
    } else {
      console.log(data);
      this.alertMessage({
        message: "Success!",
        additionalInfo: "User information updated.",
      });
      let myUpdatedUser = await this.getUser();
      this.userInfo.changeMessage(JSON.stringify(myUpdatedUser));
      return true;
    }
  }

  async getItem(Id, sectionName, clientId) {
    let params = new HttpParams().set("section", sectionName).set("Id", Id);
    if (clientId) {
      params = params.set("clientId", clientId);
    }
    let item = await this.retrieveData("get", "/api/item", params);
    if (item) {
      return item;
    }

    return null;
  }

  async getItemUser(Id, sectionName) {
    let item = await this.retrieveData(
      "get",
      "/api/item",
      new HttpParams().set("section", sectionName).set("Id", Id)
    );
    if (item) {
      return item;
    }
    return null;
  }

  async getUser(Id?) : Promise<IUser> {
    let _user = sessionStorage.getItem(Id ? "zp_user"+Id : "zp_user");
    let user:IUser;
    if(user){
      user = JSON.parse(_user);
    }
    if(!user) {
      user = await this.retrieveData(
        "get",
        "/api/user",
        Id ? new HttpParams().set("clientId", Id) : undefined
      );
      if(user) {
        sessionStorage.setItem(Id ? "zp_user" + Id : "zp_user", JSON.stringify(user));
      }
    }
    return user as IUser;
  }

  async getUserName(Id) {
    var myItem;

    myItem = await this.retrieveData(
      "get",
      "/api/name",
      new HttpParams().set("Id", Id)
    );

    if (!myItem) {
      return "Missing";
    }
    return myItem["name"];
  }

  //checking if the user has been invited to be a delegate. Checking
  //list "delegates"
  //When the delegate registers, and every time the delgate logs in, we will check
  //for more users who have added him or her as delegates
  /*async connectToMySharedPlans(user) {
    let allData = await localStorage.getItem("zenplansData");
    let myData = {};
    let mySharedPlans = [];
    let mySharedPlansAll = [{}];
    if (allData) {
      myData = JSON.parse(allData);
      if (myData) {
        mySharedPlansAll = myData["delegates"];
        if (!mySharedPlansAll) { return null; }
        this.getDelegatesUnlinkedSharedPlans(mySharedPlansAll, user, mySharedPlans);
        if (mySharedPlans.length > 0) {
          mySharedPlans.map(myPlan => {
            if (myPlan["email"]) {
              this.updateDelegateId(myPlan, user);
            }
          });
          return mySharedPlans;
        }
        else {
          return null;
        }
      }
      else {
        return null;
      }
      return null;
    }
  }*/

  //for professional users:
  async getCustomers() {
    let customers = await this.retrieveData("get", "/api/customers");
    if (customers.customers) {
      return customers.customers;
    } else {
      return [];
    }
  }

  async addOrUpdateTeamMember(member) {
    if (member) {
      let res = await this.retrieveData("post", "/api/addTeamMember", {
        teamMember: member,
      });
      if (res) {
        let user = await this.retrieveData("get", "/api/user");
      }
    }
  }

  async deleteTeamMember(member) {
    let res = await this.retrieveData("post", "/api/deleteTeamMember", {
      teamMember: member,
    });
    if (res) {
      let user = await this.retrieveData("get", "/api/user");
    }
  }
  async getAllUsers(page?, sort?, pageSize?) {
    let params = new HttpParams().set("sort", sort || '{"$natural":-1}');
    console.log('getAllUsers - sort - ', sort)
    if (page) {
      console.log('getAllUsers() page - ', page)
      params = params.set("page", page);
    }
    if (pageSize) {
      params = params.set("pageSize", pageSize);
    }
    let allUsers = await this.retrieveData("get", "/api/allUsers", params);
    console.log('getAllUsers() allUsers - ', allUsers)
    return allUsers;
  }

  async findUsers(Id?, lastName?) {
    let params = new HttpParams();
    if (Id) {
      params = params.set("Id", Id);
    } else {
      if (lastName) {
        params = params.set("lastName", lastName);
      }
    }
    let allUsers = await this.retrieveData("get", "/api/findUsers", params);
    return allUsers;
  }

  async getMySharedPlans(userId?) {
    //always retrieves for logged-in user. don't need userId anymore.
    let _mySharedPlans = sessionStorage.getItem("zp_sharedPlans");
    let mySharedPlans;
    if(!_mySharedPlans) {
      mySharedPlans = await this.retrieveData("get", "/api/sharedPlans");
      sessionStorage.setItem("zp_sharedPlans", JSON.stringify(mySharedPlans));
    }else{
      mySharedPlans = JSON.parse(_mySharedPlans);
    }
    return mySharedPlans;
  }

  async getMyProfessionalUser() {
    let professionalUser = await this.retrieveData(
      "get",
      "/api/professionalUsers"
    );
    return professionalUser;
  }

  async getProfessionalUsers() {
    let myProfessionalUser = await this.getMyProfessionalUser();
    myProfessionalUser.map(async (professionalUser) => {
      let myClient =
        professionalUser["clientFirstName"] +
        " " +
        professionalUser["clientLastName"];
      professionalUser["clientName"] = myClient;
    });

    return myProfessionalUser;
  }

  private getDelegatesUnlinkedSharedPlans(
    mySharedPlansAll: {}[],
    user: any,
    mySharedPlans: {}[]
  ) {
    if (!mySharedPlansAll) {
      return null;
    }
    for (var i = 0; i < mySharedPlansAll.length; i++) {
      try {
        if (
          mySharedPlansAll[i]["email"] &&
          mySharedPlansAll[i]["delegateId"] == ""
        ) {
          if (
            (<string>mySharedPlansAll[i]["email"]).toLowerCase() ==
            (<string>user["email"]).toLowerCase()
          ) {
            mySharedPlans.push(mySharedPlansAll[i]);
          }
        }
      } catch (error) {
        console.error("Error - getDelegatesSharedPlans", error);
      }
    }
    return mySharedPlans;
  }

  /*async updateDelegateId(myItem, delegate) {
    let allData = localStorage.getItem("zenplansData");
    //I think we should be pulling from getMessage instead of pulling out of the local storage each time.
    let myData = {};
    let mySection = [{}];
    try {
      var item = myItem;
      item["delegateId"] = delegate["Id"];
      if (allData) {
        myData = JSON.parse(allData);
        if (myData) {
          mySection = myData["delegates"];
          if (mySection) {
            var myIndex = mySection.findIndex(kk => kk["clientId"] == item["clientId"]
              && (<string>kk["email"]).toLowerCase() == (<string>delegate["email"]).toLowerCase());
            mySection.splice(myIndex, 1, item);
            myData["delegates"] = mySection;
            await localStorage.setItem("zenplansData", JSON.stringify(myData));
            this.changeMessage(JSON.stringify(myData));
            return true;
          }
        }
        else {
          return null;
        }
        return null;
      }
    }
    catch (error) {
      console.error('Error - updateDelegateId', error);
    }
  }
*/
  async deleteItem(Id, sectionName, userId) {
    let response = await this.retrieveData("post", "/api/deleteItem", {
      Id: Id,
      section: sectionName,
      clientId: userId,
    });

    if (response) {
      this.alertMessage({
        message: "Item Deleted",
        additionalInfo:
          "Please visit the Deleted Items page to restore this item if you deleted it unintentionally.",
      });
      this.changeMessage(
        JSON.stringify(await this.retrieveData("get", "/api/plan"))
      );
      return true;
    }
    return null;
  }

  async deleteDelegate(Id, sectionName, userId) {
    let response = await this.retrieveData("post", "/api/deleteItem", {
      Id: Id,
      section: sectionName,
      clientId: userId,
    });

    if (response) {
      this.changeMessage(
        JSON.stringify(await this.retrieveData("get", "/api/plan"))
      );
      return true;
    }
    return null;
  }

  async getSectionItemCount(sectionName, userId) {
    let mySection: {}[];
    let myPlan = await this.retrieveData(
      "get",
      "/api/plan",
      new HttpParams().set("clientId", userId)
    );
    if (myPlan) {
      mySection = myPlan[sectionName];
      mySection = mySection.filter((item) => item["clientId"] == userId);
      if (mySection) {
        return mySection.length;
      } else {
        return 0;
      }
    }
    return 0;
  }

  async getDelegatesCount(userId) {
    let counter = 0;
    let myDelegates = await this.retrieveData("get", "/api/delegates");

    myDelegates = myDelegates
      ? myDelegates.filter((delegate) => delegate["clientId"] == userId)
      : [];
    counter = myDelegates.length;

    return counter;
  }

  async getAllZenPlanItemCount(userId) {
    let counter = 0;
    let myData = await this.retrieveData(
      "get",
      "/api/plan",
      new HttpParams().set("clientId", userId)
    );
    let mySection: {}[];
    if (myData) {
      for (let i = 0; i < plantree.length; i++) {
        let sections = plantree[i].sections;
        for (let j = 0; j < sections.length; j++) {
          try {
            mySection = myData[sections[j]];
            if (mySection) {
              mySection = mySection.filter(
                (item) => item["clientId"] == userId
              );
              if (mySection) {
                if (mySection.length) {
                  counter += mySection.length;
                }
              }
            }
          } catch (e) {
            console.error("Error - " + e);
          }
        }
      }
      return counter;
    }
    return 0;
  }

  async getSectionStatus(sectionName) {
    let mySection = [{}];
    let result = {};
    let myData = await this.retrieveData("get", "/api/plan");
    if (myData) {
      mySection = myData[sectionName];
      if (mySection) {
        var now = new Date();
        let upToDate = mySection.filter(
          (when) => new Date(when["upToDateExpire"]) > now
        ).length;
        let forReview = mySection.filter(
          (when) => new Date(when["upToDateExpire"]) <= now
        ).length;
        result = { upToDate: upToDate, forReview: forReview };
        return result;
      }
    }
    return -1;
  }

  async getPlanCategoryStatus(categoryName, userId) {
    let upToDates = 0,
      forReviews = 0,
      missing = 0;
    //let mySections2 = plantree.filter(plan => plan.planCategory == categoryName);
    let mySections = plantree.filter(
      (plan) => plan["planCategory"] == categoryName
    )[0]["sections"];
    let myData = {};
    let mySection: {}[];
    let result = { upToDates: 0, forReviews: 0, missing: -1, reviewCodes: [] };

    let resultsPerSection = [];
    myData = await this.retrieveData("get", "/api/plan");
    if (myData) {
      mySections.map(async (section) => {
        mySection = myData[section];
        if (mySection) {
          mySection = mySection.filter((item) => item["clientId"] == userId);
          if (mySection) {
            var now = new Date();
            let myUpToDates = mySection.filter(
              (when) => new Date(when["upToDateExpire"]) > now
            ).length;

            let myForReviews = mySection.filter(
              (when) => new Date(when["upToDateExpire"]) <= now
            ).length;
            if (myForReviews > 0) {
              forReviews += myForReviews;
            }
            if (myForReviews == 0 && myUpToDates > 0) {
              upToDates += myUpToDates;
            }

            if (myForReviews > 0) {
              resultsPerSection.push({ section: section, reviewCode: 2 });
            } else {
              if (myUpToDates > 0) {
                resultsPerSection.push({ section: section, reviewCode: 1 });
              } else {
                missing++;
                resultsPerSection.push({ section: section, reviewCode: 3 });
              }
            }
          } else {
            missing++;
            //we probably want to include only sections that have not been marked by the client as "Finished"
            resultsPerSection.push({ section: section, reviewCode: 3 });
          }
        }
      });
      result = {
        upToDates: upToDates,
        forReviews: forReviews,
        missing: missing,
        reviewCodes: resultsPerSection,
      };
    }

    return result;
  }

  async getPlanCategoryCount(categoryName, userId) {
    let mySections = plantree.filter(
      (plan) => plan["planCategory"] == categoryName
    )[0]["sections"];
    var myData = {};
    var mySection: {}[];
    var count = 0;

    myData = await this.retrieveData(
      "get",
      "/api/plan",
      new HttpParams().set("clientId", userId)
    );
    if (myData) {
      mySections.map(async (section) => {
        mySection = myData[section];
        if (mySection) {
          mySection = mySection.filter((item) => item["clientId"] == userId);
          if (mySection) {
            count += mySection.length;
          }
        }
      });
    }
    return count;
  }

  async getAllPlanCategoriesCount(userId) {
    let myData: {}[];
    let mySection: {}[];
    let myCategoriesCount: {}[] = [];
    let itemCount = 0;
    myData = await this.retrieveData(
      "get",
      "/api/plan",
      new HttpParams().set("clientId", userId)
    );
    if (myData) {
      for (let i = 0; i < plantree.length; i++) {
        let sections = plantree[i].sections;
        let categoryName = plantree[i].planCategory;
        itemCount = 0;
        for (let j = 0; j < sections.length; j++) {
          try {
            mySection = myData[sections[j]];
            if (mySection) {
              mySection = mySection.filter(
                (item) => item["clientId"] == userId
              );
              if (mySection) {
                if (mySection.length) {
                  itemCount += mySection.length;
                }
              }
            }
          } catch (e) {
            console.error("Error - " + e);
          }
        }
        myCategoriesCount.push({
          categoryName: categoryName,
          count: itemCount,
        });
      }
      return myCategoriesCount;
    } else {
      for (let i = 0; i < plantree.length; i++) {
        let sections = plantree[i].sections;
        let categoryName = plantree[i].planCategory;
        myCategoriesCount.push({
          categoryName: categoryName,
          count: 0,
        });
      }
      return myCategoriesCount;
    }

    for (let i = 0; i < plantree.length; i++) {
      let sections = plantree[i].sections;
      let categoryName = plantree[i].planCategory;
      myCategoriesCount.push({
        categoryName: categoryName,
        count: 0,
      });
    }
    return myCategoriesCount;
  }

  async getAllPlanCategoriesDashboardInfo(myUser) {
    let myData: {}[];

    let myCategoriesBalance: {}[] = [];
    var myFormTemplate;

    myData = await this.retrieveData(
      "get",
      "/api/plan",
      new HttpParams().set("clientId", myUser.Id)
    );
    if (true || myData) {
      for (let i = 0; i < plantree.length; i++) {
        let sections = plantree[i].sections;
        let categoryName = plantree[i].planCategory;
        let sectionList = { sections: [] };
        let assetTotal = 0;
        let debtTotal = 0;
        let incomeTotal = 0;
        let expenseTotal = 0;
        let categoryTotal = 0;
        let totals = {};

        for (let j = 0; j < sections.length; j++) {
          let sectionCount = 0;
          try {
            let mySection = myData[sections[j]];

            //build a list of sections and how many items are in each section for this category

            //mySection = mySection.filter(item => item["clientId"] == userId);
            if (mySection && mySection.length > 0) {
              sectionCount = mySection.length; //await this.getSectionItemCount(sections[j], userId);
              //sectionList.sections.push({ "sectionName": sections[j], "itemCount": sectionCount });
              //get the template
              let templateName = plantree[i]["sectionsTemplateBaseNames"][j];
              myFormTemplate =
                await this.formTemplateService.getFormTemplateAsync(
                  templateName + "-edit"
                );
              //var isProperty = false;
              var isPrimaryResidence = false;
              var isProperty = false;
              let myFields = myFormTemplate["fields"] as [];
              //totals = this.sumSectionValueFields(myFields, mySection);
              totals = await this.sumSectionSummaryValueFields(
                myFields,
                mySection,
                sections[j],
                myUser,
                true
              );
              categoryTotal += totals["sectionTotal"];
              // assetTotal += totals["assetTotal"];
              // debtTotal += totals["debtTotal"];
              // incomeTotal += totals["incomeTotal"];
              // expenseTotal += totals["expenseTotal"];
            } else {
              //sectionList.sections.push({ "sectionName": sections[j], "itemCount": 0 });
            }
          } catch (e) { }
          // sectionList.sections.push({
          //   "sectionName": sections[j], "itemCount": sectionCount,
          //   "assets": totals["assetTotal"], "debts": totals["debtTotal"],
          //   "income": totals["incomeTotal"], "expense": totals["expenseTotal"]
          // });
          sectionList.sections.push({
            sectionName: sections[j],
            itemCount: sectionCount,
            amount: totals["sectionTotal"],
          });
        }
        let itemsPerCategory = await this.getPlanCategoryCount(
          categoryName,
          myUser.Id
        );
        var mySections = sectionList.sections;
        //mySections.sort((a,b)=>(b["itemCount"]>a["itemCount"])?1:-1);
        // mySections.sort((a, b) => (b["itemCount"] > a["itemCount"]) ? 1 : -1);

        sectionList.sections = mySections;
        // myCategoriesBalance.push({
        //   "categoryName": categoryName,
        //   "assets": assetTotal, "debts": debtTotal,
        //   "income": incomeTotal, "expense": expenseTotal, "itemCount": itemsPerCategory,
        //   "sections": sectionList.sections
        // });
        myCategoriesBalance.push({
          categoryName: categoryName,
          amount: categoryTotal,
          debts: debtTotal,
          income: incomeTotal,
          expense: expenseTotal,
          itemCount: itemsPerCategory,
          sections: sectionList.sections,
        });
      }
      return myCategoriesBalance;
    } else {
      for (let i = 0; i < plantree.length; i++) {
        let sections = plantree[i].sections;
        let categoryName = plantree[i].planCategory;
        myCategoriesBalance.push({
          categoryName: categoryName,
          assets: 0,
          debts: 0,
          income: 0,
          expense: 0,
          itemCount: 0,
          sections: [],
        });
      }
      return myCategoriesBalance;
    }
  }

  async getPlan(userId) {
    let myData = await this.retrieveData(
      "get",
      "/api/plan",
      new HttpParams().set("clientId", userId)
    );
    console.log(myData)
    if (myData) {
      return myData;
    }
  }

  async getPlanSection(userId, sectionName) {
    let myData = await this.getPlan(userId);
    if (myData && myData[sectionName]) {
      return myData[sectionName];
    } else {
      return [];
    }
  }

  async getPlanCategoryInfo(userId, categoryName) {
    var myUser = await this.getUser(userId);
    var myData;
    let mySectionData: {}[] = [];

    let myCategoryBalances: {}[] = [];
    let mySections: {}[] = [];
    let sectionTotal = 0;
    let itemTotal = 0;
    let reallyGrandTotal = 0;
    var myFormTemplate;
    var totals;
    //let sectionsList:{}[]=[];
    myData = await this.getPlan(userId);
    if (myData || true) {
      //var mySection:[];
      var theCategory = plantree.find(
        (planCategory) => planCategory["planCategory"] == categoryName
      );
      //for (let i = 0; i < myPlanTree.length; i++) {
      var myItems;
      let itemList: {}[] = [];

      for (let i = 0; i < theCategory["sections"].length; i++) {
        let mySection: {} = {};
        mySection["sectionName"] = theCategory["sections"][i];
        mySection["grandTotal"] = 0;
        mySection["items"] = [];
        let mySectionItemList = [];
        let mySectionDataLength = 0;
        if (myData) {
          mySectionData = myData[theCategory["sections"][i]];
          if (mySectionData) {
            mySectionDataLength = mySectionData.length;
          } else {
            continue;
          }
        } else {
          continue;
        }
        mySection["itemCount"] = mySectionDataLength;
        sectionTotal = 0;
        let templateName = theCategory["sectionsTemplateBaseNames"][i];
        myFormTemplate = await this.formTemplateService.getFormTemplateAsync(
          templateName + "-edit"
        );
        let myFields = myFormTemplate["fields"] as [];
        let valueFields = myFields.filter(
          (field) => field["valuetype"] != null
        );
        //totals = this.sumSectionValueFields(myFields, mySectionData);
        totals = await this.sumSectionSummaryValueFields(
          myFields,
          mySectionData,
          templateName,
          myUser,
          true
        );
        mySection["grandTotal"] = totals["sectionTotal"];
        //totals["assetTotal"] - totals["debtTotal"] + totals["incomeTotal"] - totals["expenseTotal"];
        reallyGrandTotal += mySection["grandTotal"];
        // sectionTotal = 0;
        mySection["items"] = totals["itemList"];
        mySections.push(mySection);
      }

      mySections["categoryGrandTotal"] = Math.abs(reallyGrandTotal);
    } else {
      for (let i = 0; i < theCategory["sections"].length; i++) {
        let mySection: {} = {};
        mySection["sectionName"] = theCategory["sections"][i];
        mySection["grandTotal"] = 0;
        mySection["items"] = [];
        mySection["itemCount"] = 0;
        mySections.push(mySection);
      }
      return mySections;
    }
    return mySections;
  }

  async getPlanSectionInfo(myUser, sectionName) {
    var myData;
    let mySectionData: {}[] = [];
    //let mySections: {}[] = [];
    var theSection;
    let grandTotal = 0;
    let itemTotal = 0;
    let mySection: {} = {};
    var myFormTemplate;
    var myCategory;
    myUser = await this.getUser();
    let id = myUser ? myUser.Id : undefined;
    //let sectionsList:{}[]=[];
    myData = await this.retrieveData(
      "get",
      "/api/item",
      new HttpParams().set("clientId", id).set("section", sectionName)
    );
    if (myData) {
      let propertyStatusList = {};
      if (myData["property"]) {
        myData["property"].forEach((item) => {
          propertyStatusList[item.Id] = {
            isPrimaryResidence:
              item["isPrimaryResidence"] &&
              (item["isPrimaryResidence"] == "Yes" ||
                item["isPrimaryResidence"] == true),
          };
        });
      }
      //let mymy =plantree.find(kk=>kk["section"]==sectionName);
      //let myCategory = plantree.find(kk => kk.sectionObjects["section"] == sectionName);
      //let basename = this.getBaseNameFromPlanTree(sectionName);
      //let myCategory = plantree.find(kk => kk["sectionObjects"].filter(jj => jj["sections"] == sectionName));
      //theSection = myCategory["sectionObjects"].filter(kk => kk["section"] == sectionName);
      let basename = "";
      plantree.forEach(function (category) {
        let mySection = category.sectionObjects.filter(
          (section) => section.section == sectionName
        );
        if (mySection.length > 0) {
          basename = mySection[0].baseName;
          myCategory = category;
        }
      });

      mySection["sectionName"] = sectionName;
      mySection["grandTotal"] = 0;
      mySection["items"] = [];
      mySection["category"] = myCategory;
      let mySectionItemList: {}[] = [];
      let mySectionDataLength = 0;
      mySectionData = myData;
      if (mySectionData) {
        mySectionDataLength = mySectionData.length;
      }
      mySection["itemCount"] = mySectionDataLength;
      grandTotal = 0;
      // var totals; // = [{"assetTotal":0,"debtTotal":0,"incomeTotal":0,"expenseTotal":0}];
      //totals.push({"assetTotal":0,"debtTotal":0,"incomeTotal":0,"expenseTotal":0});
      let templateName = basename; //theSection[0]["baseName"];
      myFormTemplate = await this.formTemplateService.getFormTemplateAsync(
        templateName + "-edit"
      );
      let myFields = myFormTemplate["fields"] as [];
      var totals = await this.sumSectionSummaryValueFields(
        myFields,
        mySectionData,
        templateName,
        myUser.Id,
        true,
        propertyStatusList
      );
      // try {

      //   //myItems = myData[mySection[j]];

      //   let templateName = basename; //theSection[0]["baseName"];
      //   myFormTemplate = await this.formTemplateService.getFormTemplateAsync(templateName + "-edit");
      //   let myFields = myFormTemplate["fields"] as [];
      //   totals = await this.sumSectionSummaryValueFields(myFields, mySectionData, templateName, myUser.Id, true, propertyStatusList);
      //   // if (templateName == 'property') {
      //   //   //Getting mortgage values for properties from mortgages
      //   //   //(what about utilities?)
      //   //   mySectionData.forEach(async item => {
      //   //     let isPrimaryResidence = item["isPrimaryResidence"];
      //   //     let primaryResidence: boolean = isPrimaryResidence == "Yes" || isPrimaryResidence == true;
      //   //     let mortgageValues = await this.getLinkedItemMortgagesValues(item, myUser, primaryResidence);
      //   //     let utilitiesExpense = await this.getLinkedItemUtilitiesValues(item, myUser, primaryResidence);
      //   //     if (primaryResidence) {
      //   //       totals["debtTotal"] += mortgageValues["propertyDebt"];
      //   //       totals["expenses"] += mortgageValues["propertyPrimaryMortgageRepayments"];
      //   //       totals["expenses"] += utilitiesExpense;
      //   //     }
      //   //     else {
      //   //       totals["assetTotal"] -= mortgageValues["propertyDebt"];;
      //   //       totals["income"] -= mortgageValues["propertyNonPrimaryMortgageRepayment"];
      //   //       totals["income"] -= utilitiesExpense;
      //   //     }
      //   //   });
      //   // }
      //   // if (!totals) {
      //   //   var asdf = 0;
      //   // }
      // }
      // catch (e) {
      //   console.log(e);
      //   console.error("Scan Sections Error - " + e);
      // }

      //mySections.push(mySection);

      // mySection["grandTotal"] = totals["assets"] - totals["debts"] + totals["income"] - totals["expenses"]; //grandTotal;
      // mySection["items"] = totals["itemList"]; //mySectionItemList;
      mySection["grandTotal"] =
        totals["assetTotal"] -
        totals["debtTotal"] +
        totals["incomeTotal"] -
        totals["expenseTotal"]; //grandTotal;
      mySection["assetTotal"] = totals["assetTotal"];
      mySection["debtTotal"] = totals["debtTotal"];
      mySection["incomeTotal"] = totals["incomeTotal"];
      mySection["expenseTotal"] = totals["expenseTotal"];
      mySection["items"] = totals["itemList"]; //mySectionItemList;
    } else {
      let mySection: {} = {};
      mySection["sectionName"] = sectionName;
      mySection["grandTotal"] = 0;
      mySection["items"] = [];
      mySection["itemCount"] = 0;
      //mySections.push(mySection);

      return mySection;
    }

    return mySection;
  }

  // async getPlanCategoriesDashboardInfoByCategory(userId,myCategoryName) {
  //   // let allInfo = await this.getAllPlanCategoriesDashboardInfo(userId);
  //   // let categoryInfo = allInfo.filter(categoryName=>categoryName==myCategoryName)
  //   // return categoryInfo;
  // }
  // async getAmountMonthlyOrYearly(myData, sectionName, myValue) {
  //   //handle general expenses
  //   //general expenses is a one item only section which is pure expenses
  //   let generalExpenses = myData[sectionName];
  //   if (generalExpenses) {
  //     //get the template for general expenses
  //     let baseName = this.getBaseNameFromPlanTree(sectionName);
  //     let geFormTemplate = await this.formTemplateService.getFormTemplateAsync(baseName + "-edit");
  //     let totalGeneralExpense = 0;
  //     //expenseTotal += totalGeneralExpense;
  //   }
  // }

  // async getBaseNameFromPlanTree(sectionName) {
  //   var templateBaseName = "";
  //   //let sections = plantree.find(category => category == categoryName).sections;
  //   let templateBaseNameIndex = plantree.findIndex(section => section == sectionName);
  //   templateBaseName = plantree.find(templateSection => templateSection.sectionsTemplateBaseNames[templateBaseNameIndex])[0];
  //   return templateBaseName;
  // }

  // async getSectionsFromPlanTree(sectionName) {
  //   var templateBaseName = "";
  //   //let sections = plantree.find(category => category == categoryName).sections;
  //   let templateBaseNameIndex = plantree.findIndex(section => section == sectionName);
  //   templateBaseName = plantree.find(templateSection => templateSection.sectionsTemplateBaseNames[templateBaseNameIndex])[0];
  //   return templateBaseName;
  // }

  async checkPassword(sectionName, userName, password) {
    delete this.token;
    this.emptyCache();
    var response = await this.retrieveData("post", "/api/login", {
      user: { email: userName, password: password },
    });

    if (response && response.zptoken) {
      this.token = response.zptoken;
      localStorage.setItem("token", this.token);
      if (!this._cache || !this._cache.plan) {
        await this.revalidateCache(); //in case we try to load cache before token has been stored.
      }
      //        this.headers = this.headers.set("authorization", response.token);
      return response.Id;
    } else {
      return null;
    }
  }

  async getPlanCategory(planName) {
    var categoryName = "-1";
    plantree.forEach((category) => {
      if (category["sections"].includes(planName)) {
        categoryName = category.planCategory;
      }
    });
    return categoryName;
  }

  markSectionCompleted(myUser, sectionName, completed: boolean) {
    let success = true;
    try {
      let sectionList: {}[] = myUser["sectionList"];
      let mySection = sectionList.find(
        (section) => section["section"] == sectionName
      );
      mySection["complete"] = completed;
      this.updateItem(JSON.stringify(myUser), "users");
    } catch (e) {
      success = false;
      console.error("markSectionCompleted Fail - " + e);
    }
    return success;
  }

  async logChanges(myItem, sectionName, clientId) {
    let allData = await localStorage.getItem("zenplansChangeLog");
    var myData = {};
    var mySection: {}[] = [];
    var item = myItem;
    if (!allData) {
      allData = "[]";
      await localStorage.setItem("zenplansChangeLog", allData);
    }
    if (allData) {
      myData = JSON.parse(allData);
      if (myData) {
        //get current item data before updating
        var oldItem = await this.getItem(
          item["Id"],
          sectionName,
          item["clientId"]
        );
        for (let key in oldItem) {
          let child = oldItem[key];
          if (child != item[key]) {
            //it has been changed
            if (key !== "lastUpdate") {
              this.addLog(
                sectionName,
                item["Id"],
                item["lastUpdateBy"],
                key,
                oldItem[key],
                item[key],
                "update"
              );
            }
          }
        }
      } else {
        return null;
      }
      return null;
    }
  }

  async addLog(
    tableName,
    recordId,
    userId,
    fieldName,
    oldValue,
    newValue,
    action
  ) {
    try {
      let allData = await localStorage.getItem("zenplansChangeLog");
      var myData: {}[];
      if (!allData) {
        allData = "[]";
        await localStorage.setItem("zenplansChangeLog", allData);
      }
      if (allData) {
        myData = JSON.parse(allData);
        if (myData) {
          myData.push({
            tableName: tableName,
            recordId: recordId,
            userId: userId,
            fieldName: fieldName,
            oldValue: oldValue,
            newValue: newValue,
            action: action,
            timestamp: new Date(),
          });
          await localStorage.setItem(
            "zenplansChangeLog",
            JSON.stringify(myData)
          );
        } else {
          return null;
        }
        return null;
      }
    } catch (e) {
      console.error("addLog Error - " + e.message);
    }
  }

  async getLastChangeLog(recordId) {
    let allData = await localStorage.getItem("zenplansChangeLog");
    var myData: {}[];
    var myRecordChanges: {}[];
    var myRecordChanges2: {}[] = [];
    var groupBy = function (xs, key) {
      return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
      }, {});
    };
    var maxLastUpdate = function (xs, key) {
      return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[Math.max(x[key])] || []).push(x);
      }, {});
    };
    if (allData) {
      myData = JSON.parse(allData);
      if (myData) {
        try {
          myRecordChanges = myData.filter(
            (record) => record["recordId"] == recordId
          );
          myRecordChanges = groupBy(myRecordChanges, "fieldName");
          var max = new Date();
          max.setFullYear(1999);
          // myRecordChanges.map(recordIdGroup => {
          //   myRecordChanges2.push((recordIdGroup as []).map(function (ele) { if (ele["timestamp"] > max) { max = ele["timestamp"] } }))
          // });
          for (let key in myRecordChanges) {
            var child: [];
            child = myRecordChanges[key] as [];
            let lastRecord = child.reduce((max, myRecord) =>
              max["timestamp"] > myRecord["timestamp"] ? max : myRecord
            );
            myRecordChanges2.push(lastRecord);
            //myRecordChanges2.push(child.map(function (ele) { if (ele["timestamp"] > max) { max = ele["timestamp"] } }));
          }
          //myRecordChanges = groupBy(myRecordChanges,'timestamp');
          //myRecordChanges = myRecordChanges.
          // myRecordChanges = myData.filter(record=>record["Id"]==recordId)
          // .reduce(function(rv,x){
          //   (rv[x[key]] = rv[x[key]] || []).push(x);
          //   return rv;
          // }, {});

          // _(myData)
          // .groupBy(item=>item.fieldName)
          // .filter(item=>item.Id==recordId)
          // .max(item=>item.timestamp);
          return myRecordChanges2;
        } catch (e) {
          console.error("getLastChangeLog Error - " + e.message);
        }
      } else {
        return null;
      }
      return null;
    }
  }

  async getSharedPlans(user?) {
    //don't need user param anymore.
    let mySharedPlans = await this.getMySharedPlans();
    if (mySharedPlans && mySharedPlans instanceof Array) {
      mySharedPlans.map(async (sharedPlan) => {
        let myClient =
          sharedPlan["clientFirstName"] + " " + sharedPlan["clientLastName"];
        sharedPlan["clientName"] = myClient;
      });
      return mySharedPlans;
    } else {
      return [];
    }
  }

  async delegateIsConnected(delegateId, clientId) {
    if (delegateId == "") {
      return false;
    }
    let counter = 0;
    let allData = await localStorage.getItem("zenplansData");
    let myData = {};
    var mySharedPlans: [];
    let retval = false;
    if (allData) {
      myData = JSON.parse(allData);
      if (myData) {
        if (myData["delegates"]) {
          mySharedPlans = myData["delegates"];
          let mySharedPlans2 = mySharedPlans.filter(
            (sharedPlan) =>
              sharedPlan["delegateId"] == delegateId &&
              sharedPlan["clientId"] == clientId
          );
          // //counter = mySharedPlans.length;
          if (mySharedPlans2.length > 0) {
            retval = true;
          }
        }
      }
    }
    return retval;
  }

  async getSectionItemIdsNamesAndTotals(sectionName, itemType?) {
    let itemIdsAndNames: [{}] = [{}];
    itemIdsAndNames.pop();
    let mySection = await this.retrieveData(
      "get",
      "/api/item",
      new HttpParams().set("section", sectionName)
    );

    if (itemType) {
      //for getting all items with a specified itemType
      mySection
        .filter((kk) => kk["itemType"] == itemType)
        .map((item) => {
          itemIdsAndNames.push({ Id: item["Id"], itemName: item["itemName"] });
        });
    } else {
      //get all items in the section
      mySection.map((item) => {
        itemIdsAndNames.push({
          Id: item["Id"],
          itemName: item["itemName"],
          utilityType: item["utilityType"],
          insuranceType: item["insuranceType"],
        });
      });
    }
    if (itemIdsAndNames.length) {
      return itemIdsAndNames;
    }
    return null;
  }

  async getDeletedItems() {
    let myDeletedItems = await this.retrieveData(
      "get",
      "/api/deleted",
      undefined,
      true
    );
    myDeletedItems.results.reverse();
    return myDeletedItems;
  }

  async permanentlyDeleteDeletedItem(id, restore = false) {
    let deletedTheItem = await this.retrieveData("post", "/api/deleted", {
      Id: id,
      restore: restore,
    });
    if (deletedTheItem.success) {
      return true;
    }
    return false;
  }

  async requestAccess(item) {
    if (!item) {
      return false;
    } else {
      let res = await this.retrieveData("post", "/api/requestAccess", {
        item: item,
      });
      if (res.success) {
        return true;
      }
      return false;
    }
  }

  sumSectionValueFields(myFields, mySection) {
    var isProperty;
    var isPrimaryResidence;
    let assetTotal = 0;
    let debtTotal = 0;
    let incomeTotal = 0;
    let expenseTotal = 0;
    let mySectionItemList: {}[] = [];
    var totals: {} = {
      assetTotal: 0,
      debtTotal: 0,
      incomeTotal: 0,
      expenseTotal: 0,
      itemList: [],
    };
    var kk = myFields.find((field) => field["fieldid"] == "isPrimaryResidence");
    if (kk) {
      //check if isPrimaryResedence is true
      isProperty = true;
    }
    let valueFields = myFields.filter(
      (field) => field["valuetype"] != null || field["valueType"] != null
    );
    mySection.forEach((item) => {
      if (isProperty) {
        //check if is a primary property
        isPrimaryResidence =
          item["isPrimaryResidence"] == "Yes" ||
          item["isPrimaryResidence"] == true;
      }
      valueFields.forEach((field) => {
        //scan the data for this field

        if (isNaN(item[field["fieldid"]])) {
          return;
        }
        if (!item[field["fieldid"]]) {
          return;
        }
        if (item[field["fieldid"]] == null) {
          return;
        }
        let valueType = field["valuetype"];
        //if it is a property and not a primary resedence, we will sum all values into the assetTotal

        switch (valueType) {
          case "asset":
            //get the data
            assetTotal += this.currencyConvert.monetaryValueInDefaultCurrency(
              item[field["fieldid"]]
            );
            //sectionAssetTotal += item[field["fieldid"]];
            break;
          case "debtsdebt":
            debtTotal += this.currencyConvert.monetaryValueInDefaultCurrency(
              item[field["fieldid"]]
            );
            break;
          case "debt":
            // if (isProperty && !isPrimaryResidence) { //properties are calculated differently
            //   assetTotal -= item[field["fieldid"]];
            //   //sectionAssetTotal -= item[field["fieldid"]];
            // }
            // else {
            debtTotal += this.currencyConvert.monetaryValueInDefaultCurrency(
              item[field["fieldid"]]
            );
            //sectionDebtTotal += item[field["fieldid"]];
            // }
            break;
          case "income":
            // if (isProperty && !isPrimaryResidence) { //properties are calculated differently
            //   assetTotal += item[field["fieldid"]];
            //   //sectionAssetTotal += item[field["fieldid"]];
            // }
            // else {
            incomeTotal += this.currencyConvert.monetaryValueInDefaultCurrency(
              item[field["fieldid"]]
            );
            //sectionIncomeTotal += item[field["fieldid"]];
            //}
            break;
          case "expense":
            if (isProperty && !isPrimaryResidence) {
              //properties are calculated differently
              incomeTotal -=
                this.currencyConvert.monetaryValueInDefaultCurrency(
                  item[field["fieldid"]]
                );
              //sectionAssetTotal -= item[field["fieldid"]];
            } else {
              expenseTotal +=
                this.currencyConvert.monetaryValueInDefaultCurrency(
                  item[field["fieldid"]]
                );
              //sectionExpenseTotal += item[field["fieldid"]];
            }
            break;
          case "incomeMonthly":
            // if (isProperty && !isPrimaryResidence) { //properties are calculated differently
            //   assetTotal += item[field["fieldid"]] * 12;
            //   //sectionAssetTotal += item[field["fieldid"]] * 12;
            // }
            // else {
            incomeTotal +=
              this.currencyConvert.monetaryValueInDefaultCurrency(
                item[field["fieldid"]]
              ) * 12;
            //sectionExpenseTotal += item[field["fieldid"]] * 12;
            //}
            break;
          case "expenseMonthly":
            if (isProperty && !isPrimaryResidence) {
              //properties are calculated differently
              incomeTotal -=
                this.currencyConvert.monetaryValueInDefaultCurrency(
                  item[field["fieldid"]]
                ) * 12;
              //sectionAssetTotal -= item[field["fieldid"]] * 12;
            } else {
              expenseTotal +=
                this.currencyConvert.monetaryValueInDefaultCurrency(
                  item[field["fieldid"]]
                ) * 12;
              //sectionExpenseTotal += item[field["fieldid"]] * 12;
            }
            break;
          case "sharePrice":
            //get the number of shares
            let shareCount = item["shareCount"];
            assetTotal +=
              (this.currencyConvert.monetaryValueInDefaultCurrency(
                item["sharePrice"]
              ) *
                shareCount) /
              100; //sharePrice in pence, value of shares needs to be converted to GBP hence /100
            //sectionAssetTotal += item["sharePrice"] * shareCount;
            break;
          case "expenseMonthlyOrYearly":
            let monthlyYearlyField = "";
            if (field["valueMonthOrYearFieldId"]) {
              monthlyYearlyField = field["valueMonthOrYearFieldId"]; //myFields.find(field => field["valueMonthOrYearFieldId"]);
            } else {
              //it is general expenses and we need to build the name of the per month/per year field
              monthlyYearlyField = item[field["fieldid"] + "freq"];
            }
            //let monthlyYearlyField = item["valueMonthOrYearFieldId"]//myFields.find(field => field["valueMonthOrYearFieldId"]);
            switch (item[monthlyYearlyField]) {
              case "Per Month":
                expenseTotal +=
                  this.currencyConvert.monetaryValueInDefaultCurrency(
                    item[field["fieldid"]]
                  ) * 12;
                //sectionExpenseTotal += item[field["fieldid"]] * 12;
                break;
              case "Per Year":
                expenseTotal +=
                  this.currencyConvert.monetaryValueInDefaultCurrency(
                    item[field["fieldid"]]
                  );
                //sectionExpenseTotal += item[field["fieldid"]];
                break;
            }
            break;
          case "":
            break;
        }
      });
      mySectionItemList.push({
        itemName: item["itemName"],
        Id: item["Id"],
        itemTotal: assetTotal - debtTotal + incomeTotal - expenseTotal,
      });
    });
    totals["assetTotal"] = assetTotal;
    totals["debtTotal"] = debtTotal;
    totals["incomeTotal"] = incomeTotal;
    totals["expenseTotal"] = expenseTotal;
    totals["itemList"] = mySectionItemList;
    return totals;
  }

  async getAllFinancialSummaryInfo(myUser, jointOwnersStats, selectedOwners) {
    let myData: {}[];
    let mySection: {}[];
    let myCategoriesBalance: {}[] = [];
    let assetTotal,
      debtTotal,
      incomeTotal,
      expenseTotal,
      grandTotal = 0;
    let sectionAssetTotal,
      sectionDebtTotal,
      sectionIncomeTotal,
      sectionExpenseTotal,
      sectionGrandTotal = 0;
    var myFormTemplate;
    let clientId = myUser.sharedPlanUserId
      ? myUser.sharedPlanUserId
      : myUser.Id;
    var totals: {} = {
      assetTotal: 0,
      debtTotal: 0,
      incomeTotal: 0,
      expenseTotal: 0,
      sections: [],
    };
    myData = await this.retrieveData(
      "get",
      "/api/plan",
      new HttpParams().set("clientId", clientId)
    );
    if (myData) {
      let propertyStatusList = {};
      if (myData["property"]) {
        myData["property"].forEach((item) => {
          propertyStatusList[item.Id] = {
            isPrimaryResidence:
              item["isPrimaryResidence"] == "Yes" ||
              item["isPrimaryResidence"] == true,
          };
        });
      }
      for (let i = 0; i < plantree.length; i++) {
        let sections = plantree[i].sections;
        let categoryName = plantree[i].planCategory;
        let sectionList = { sections: [] };
        for (let j = 0; j < sections.length; j++) {
          let sectionCount = 0;
          try {
            let sectionName = sections[j];
            mySection = myData[sections[j]];
            if (mySection && mySection.length > 0) {
              sectionCount = mySection.length; //await this.getSectionItemCount(sections[j], myUser.Id);
              //get the template
              let templateName = plantree[i]["sectionsTemplateBaseNames"][j];
              myFormTemplate =
                await this.formTemplateService.getFormTemplateAsync(
                  templateName + "-edit"
                );
              let myFields = myFormTemplate["fields"] as [];
              //lets check if thisis a property and then below if this is a primary resedence or not
              //does it have a field called "isPrimaryResedence"?
              let sectionTotals = await this.sumSectionSummaryValueFields(
                myFields,
                mySection,
                sectionName,
                myUser,
                jointOwnersStats,
                propertyStatusList,
                selectedOwners
              );
              //this.sumSectionFinancialSummaryValueFields(myFields, mySection, sectionName);
              totals["assetTotal"] += sectionTotals["assetTotal"];
              totals["debtTotal"] += sectionTotals["debtTotal"];
              totals["incomeTotal"] += sectionTotals["incomeTotal"];
              totals["expenseTotal"] += sectionTotals["expenseTotal"];
              totals["sections"].push({
                sectionName: sectionName,
                categoryName: categoryName,
                assetItems: sectionTotals["assetItemList"],
                assetTotal: sectionTotals["assetTotal"],
                debtItems: sectionTotals["debtItemList"],
                debtTotal: sectionTotals["debtTotal"],
                incomeItems: sectionTotals["incomeItemList"],
                incomeTotal: sectionTotals["incomeTotal"],
                expenseItems: sectionTotals["expenseItemList"],
                expenseTotal: sectionTotals["expenseTotal"],
              });
            } else {
            }
          } catch (e) {
            let kk = 0;
          }
        }
      }
      return totals;
    }
  }

  async mortgageExtendedInformation(userId, mortgage) {
    if (mortgage) {
      let propertyId;
      if (mortgage.propertyId) {
        propertyId = mortgage.propertyId;
      }
      let propertySection = await this.getPlanSection(userId, "property");
      if (propertySection && propertySection.length) {
        let propertiesForThisMortgage = propertySection.reduce(
          (accum: [any], property: any): [any] => {
            if (property.propertyMortgaged) {
              if (
                property.propertyMortgages.find(mortgage.Id) ||
                property.Id === propertyId
              ) {
                accum.push(property);
              }
            }
            return accum;
          },
          []
        );
        return propertiesForThisMortgage;
      }
    }
    return [];
  }

  async getLinkedItemMortgagesValues(myItem, myUser, primaryResidence) {
    try {
      var retObject: {} = {
        propertyDebt: 0,
        propertyPrimaryMortgageRepayments: 0,
        propertyNonPrimaryMortgageRepayments: 0,
      };

      var myMortgages: [] = myItem["propertyMortgages"];
      if (myMortgages && myMortgages.length > 0) {
        //myMortgages = objectValues[index] as [];
        //if (myMortgages && myMortgages.length > 0) {
        //let myMortgageFormTemplate = await this.ftService.getFormTemplateAsync("mortgage-edit");
        let clientId = myUser.sharedPlanUserId
          ? myUser.sharedPlanUserId
          : myUser.Id;
        for (let i = 0; i < myMortgages.length; i++) {
          // await myMortgages.forEach(async mortgageId => {
          //get the item
          let myMortgage = await this.getItem(
            myMortgages[i],
            "mortgages",
            clientId
          );
          let outstandingBalance = myMortgage["outstandingBalance"];
          retObject["propertyDebt"] +=
            this.currencyConvert.monetaryValueInDefaultCurrency(
              outstandingBalance
            );
          let monthlyRepayments =
            this.currencyConvert.monetaryValueInDefaultCurrency(
              myMortgage["monthlyExpenditure"]
            );
          if (primaryResidence) {
            retObject["propertyPrimaryMortgageRepayments"] += monthlyRepayments;
          } else {
            retObject["propertyNonPrimaryMortgageRepayments"] +=
              monthlyRepayments;
          }
        }
      }
      return retObject;
    } catch (e) {
      let kk = 0;
    }
  }

  async getLinkedItemUtilitiesValues(myItem, myUser, primaryResidence) {
    var retVal = 0;
    var myUtilities: [] = [];
    if (myItem["propertyUtilities"]) {
      myUtilities = myItem["propertyUtilities"] as [];
      if (myUtilities && myUtilities.length > 0) {
        let clientId = myUser.sharedPlanUserId
          ? myUser.sharedPlanUserId
          : myUser.Id;
        for (let i = 0; i < myUtilities.length; i++) {
          //await myUtilities.forEach(async utilityId => {
          //get the item
          var myUtility;
          try {
            myUtility = await this.getItem(
              myUtilities[i],
              "utilities",
              clientId
            );
          } catch (e) {
            let kk = 0;
          }
          let expense = this.currencyConvert.monetaryValueInDefaultCurrency(
            myUtility["utilityCost"]
          );
          let multiplier = 12;
          let monthOrYear = myUtility["perMonthYear"];
          if (monthOrYear == "Per Year") {
            multiplier = 1;
          }
          if (expense) {
            retVal += expense * multiplier;
          }
        }
      }
    }
    return retVal;
  }

  async getLinkedItemInsurancesValues(myItem, myUser, primaryResidence) {
    var retVal = 0;
    var myInsurances: [] = [];
    if (myItem["propertyInsurances"]) {
      myInsurances = myItem["propertyInsurances"] as [];
      if (myInsurances && myInsurances.length > 0) {
        let clientId = myUser.sharedPlanUserId
          ? myUser.sharedPlanUserId
          : myUser.Id;
        for (let i = 0; i < myInsurances.length; i++) {
          //await myUtilities.forEach(async utilityId => {
          //get the item
          var myInsurance;
          try {
            myInsurance = await this.getItem(
              myInsurances[i],
              "insurance",
              clientId
            );
          } catch (e) {
            let kk = 0;
          }
          let expense = this.currencyConvert.monetaryValueInDefaultCurrency(
            myInsurance["premium"]
          );
          let multiplier = 12;
          let monthOrYear = myInsurance["perMonthYear"];
          if (monthOrYear == "Per Year") {
            multiplier = 1;
          }
          if (expense) {
            retVal += expense * multiplier;
          }
        }
      }
    }
    return retVal;
  }

  async getCanEdit(myUser, categoryName) {
    let retval = false;
    if (myUser.sharedPlanUserId) {
      //a delegate is looking at this info
      // let categoryName = await this.getPlanCategory(sectionTitle);
      // if (!categoryName) { return; }
      switch (categoryName) {
        case "my assets":
          if (myUser.delegate["assetsPermission"] == "contributor") {
            retval = true;
          }
          break;
        case "my debts":
          if (myUser.delegate["debtsPermission"] == "contributor") {
            retval = true;
          }
          break;
        case "my daily life":
          if (myUser.delegate["dailyLifePermission"] == "contributor") {
            retval = true;
          }
          break;
        case "my digital life":
          if (myUser.delegate["digitalLifePermission"] == "contributor") {
            retval = true;
          }
          break;
        case "my wishes":
          if (myUser.delegate["wishesPermission"] == "contributor") {
            retval = true;
          }

          break;
      }
      return retval;
    } else {
      //the client himself is deleting
      return true;
    }
  }

  // public setCurrentOwnerSelected(financialSummarySelectedOwners) {
  //   console.log('setCurrentOwnerSelected(), financialSummarySelectedOwners - ', financialSummarySelectedOwners)
  //   this.selectedOwners = financialSummarySelectedOwners;
  //   console.log('this.selectedOwners - ', this.selectedOwners)
  // }

  isPlanHolderASelectedOwner(selectedOwners) {
    for (let selectedOwner of selectedOwners) {
      // console.log('isPlanHolderASelectedOwner(), selectedOwner - ', selectedOwner)
      if (selectedOwner.default) {
        return true;
      }
    }
    return false;
  }
  determineShareOfSelectedNewJointOwners(newJointOwners, selectedOwners) {

    let totalShare = 0.0;
    for (let selectedOwner of selectedOwners) {
      for (let jointOwner of newJointOwners) {
        const jointOwnerName = jointOwner.owner.first + jointOwner.owner.last;
        const selectedOwnerName = selectedOwner.first + selectedOwner.last;
        if (selectedOwnerName === jointOwnerName) {
          totalShare += (jointOwner.share * 0.01);
        }
      }
    }
    return totalShare;
  }
  determineNewJointOwnerItemShare(myUser, item, selectedOwners) {
    if (selectedOwners == undefined) {
      if (myUser && myUser.jointOwners) {
        selectedOwners = [myUser.jointOwners[0]];
      }
    }

    const jointOwnersList = myUser.jointOwners;
    if (jointOwnersList) {
      // if there is only one myUser.jointOwners then always return 1.0;
      if (jointOwnersList.length == 1) {
        return 1;
      } else {
        // if there is more than one myUser.jointOwners but all of them are selected then always return 1.0;
        if (!selectedOwners) {
          return 1;
        }
        if (jointOwnersList.length == selectedOwners.length) {
          return 1;
        } else {
          // if there is more than one myUser.jointOwners AND planHolder IS SELECTED:
          if (item.newJointOwners) {
            //    when an item HAS newJointOwners calculate the share of the selected owners and return that;
            return this.determineShareOfSelectedNewJointOwners(item.newJointOwners, selectedOwners);
          } else {
            if (this.isPlanHolderASelectedOwner(selectedOwners)) {
              // if there is more than one myUser.jointOwners AND planHolder IS SELECTED:
              //    when an item HAS NO newJointOwners then return 1.0;
              return 1.0;
            } else {
              // else if planHolder is NOT SELECTED:
              //    when an item HAS NO newJointOwners then return 0;
              return 0;
            }

          }
        }
      }
    } else {
      console.log('7.')
      return 1;
    }

  }
  //sumSectionFinancialSummaryValueFields - probably should be merged ith the below
  async sumSectionSummaryValueFields(
    myFields,
    mySection,
    sectionName,
    myUser,
    jointOwnersStats?,
    propertyList?,
    selectedOwners?
  ) {
    var isProperty;
    var isPrimaryResidence = false;
    let collatedWithRentalResidence = false;
    let assetTotal = 0;
    let debtTotal = 0;
    let incomeTotal = 0;
    let expenseTotal = 0;
    let itemTotal = 0;
    let sectionTotal = 0;
    let incomeShare = 1;
    var jointOwners: {}[] = [];
    let mySectionItemList: {}[] = [];
    var totals: {} = {
      assetTotal: 0,
      debtTotal: 0,
      incomeTotal: 0,
      expenseTotal: 0,
      assetItemList: [],
      debtItemList: [],
      incomeItemList: [],
      expenseItemList: [],
      itemList: [],
      sectionTotal: 0,
    };
    let assetItem: {} = {};
    let debtItem: {} = {};
    let incomeItem: {} = {};
    let expenseItem: {} = {};
    var kk = myFields.find((field) => field["fieldid"] == "isPrimaryResidence");
    if (kk) {
      //check if isPrimaryResedence is true - probably better to chec if it is rented
      isProperty = true;
    }
    if (sectionName == "general expenses") {
      let kk = 0;
    }
    if (sectionName == "other assets") {
      let kk = 0;
    }
    let valueFields = myFields.filter(
      (field) => field["valuetype"] != null || field["valueType"] != null
    );
    for (let item of mySection) {
      assetItem = {
        sectionName: sectionName,
        itemName: item["itemName"],
        Id: item["Id"],
        itemTotal: 0,
      };
      debtItem = {
        sectionName: sectionName,
        itemName: item["itemName"],
        Id: item["Id"],
        itemTotal: 0,
      };
      incomeItem = {
        sectionName: sectionName,
        itemName: item["itemName"],
        Id: item["Id"],
        itemTotal: 0,
      };
      expenseItem = {
        sectionName: sectionName,
        itemName: item["itemName"],
        Id: item["Id"],
        itemTotal: 0,
      };
      itemTotal = 0;

      incomeShare = this.determineNewJointOwnerItemShare(myUser, item, selectedOwners);

      if (jointOwnersStats) {
        if (isProperty) {
          //is it jointly owned and if yes, what percent is the income shared
          if (item["jointOwners"] || item["jointHolders"]) {
            jointOwners = item["jointOwners"] || item["jointHolders"];
            if (jointOwners.length > 0) {
              let fiscalOwners = [jointOwners[0]]; // we removed fiscalOwners //.filter(owner => owner["Fiscal"] == true);
              if (fiscalOwners.length > 0) {
                //formarray objects are abstract and could be used for many things.
                //in the name of laziness - since right now we now that all the four and three columns are joint owners
                //dividing by percent we do the following:
                if (
                  fiscalOwners[0]["Percentage"] ||
                  fiscalOwners[0]["Percentage"] === 0
                ) {
                  //if (myFields.filter(field => (field["inputType"] == "formarrayfourcolumns"))) {
                  fiscalOwners.forEach((owner) => {
                    //income percentage is used only if it is different from ownership percentage
                    if (
                      owner["IncomePercentage"] &&
                      owner["IncomePercentage"] > 0
                    ) {
                      if (incomeShare == 1) {
                        incomeShare = 0;
                      } //this might be dangerous it the user only adds him or herself
                      incomeShare += +(owner["IncomePercentage"] / 100).toFixed(
                        3
                      );
                    } else {
                      if (owner["Percentage"] && owner["Percentage"] > 0) {
                        if (incomeShare == 1) {
                          incomeShare = 0;
                        } //this might be dangerous it the user only adds him or herself
                        incomeShare += +(owner["Percentage"] / 100).toFixed(3);
                      }
                    }
                  });
                } else {
                  let numberOfFiscalOwners = fiscalOwners.length;
                  incomeShare = +(1 / numberOfFiscalOwners).toFixed(3);
                }
              }
            }
          }
        }
        if (!isProperty) {
          if (item["jointOwners"] || item["jointHolders"]) {
            jointOwners = item["jointOwners"] || item["jointHolders"];
            if (jointOwners.length > 1) {
              //if there is only one joint owner - fuck it
              let fiscalOwners = [jointOwners[0]]; //eliminated checkbox to say if the split is fiscal //.filter(owner => owner["Fiscal"] == true);
              if (fiscalOwners.length > 0) {
                //formarray objects are abstract and could be used for many things.
                //in the name of laziness - since right now we now that all the four and three columns are joint owners
                //dividing by percent we do the following:
                if (
                  myFields.filter(
                    (field) => field["inputType"] == "formarraythreecolumns"
                  )
                ) {
                  //mortgages etc.
                  fiscalOwners.forEach((owner) => {
                    //income percentage is used only if it is different from ownership percentage
                    if (owner["Percentage"] && owner["Percentage"] > 0) {
                      if (incomeShare == 1) {
                        incomeShare = 0;
                      } //this might be dangerous it the user only adds him or herself
                      incomeShare += +(owner["Percentage"] / 100).toFixed(3);
                    } else {
                      if (owner["Percentage"] == 0 && incomeShare == 1) {
                        incomeShare = 0;
                      }
                      incomeShare += +(owner["Percentage"] / 100).toFixed(3);
                    }
                  });
                }

                // if (myFields.filter(field => (field["inputType"] === "formarraytwocolumns"))) {//other asset

                // }
                let fieldExists = myFields.filter(
                  (field) => field["inputType"] === "formarray"
                );
                if (fieldExists && fieldExists.length) {
                  //bank accounts
                  let numberOfFiscalOwners = fiscalOwners.length;
                  incomeShare = +(1 / numberOfFiscalOwners).toFixed(3);
                }
              }
            }
          }
        }
      }

      if (isProperty) {
        //check if is a primary property
        isPrimaryResidence = false;
        try {
          isPrimaryResidence =
            item["isPrimaryResidence"] == "Yes" ||
            item["isPrimaryResidence"] == true;
          var mortgageValues;
          try {
            mortgageValues = await this.getLinkedItemMortgagesValues(
              item,
              myUser,
              isPrimaryResidence
            );
            // try{
            // itemTotal -= mortgageValues["propertyDebt"] + mortgageValues["propertyPrimaryMortgageRepayments"]*12 + mortgageValues["propertyNonPrimaryMortgageRepayments"]*12
            // }
            // catch(e){
            //     itemTotal = 0;
            //     //log bug here
            // }
          } catch (e) {
            let kk = 0;
          }
          let utilitiesExpense = await this.getLinkedItemUtilitiesValues(
            item,
            myUser,
            isPrimaryResidence
          );

          let insuranceExpense = await this.getLinkedItemInsurancesValues(
            item,
            myUser,
            isPrimaryResidence
          );

          // if (isPrimaryResidence) {
          //   if (mortgageValues) {
          //     if (mortgageValues["propertyDebt"]) {
          //       totals["debtTotal"] += mortgageValues["propertyDebt"];
          //       //totals["debtItemList"].push({ "sectionName": sectionName, "itemName": "Mortgage", "Id": item["Id"], "itemTotal": mortgageValues["propertyDebt"] });
          //       debtItem["itemTotal"] += mortgageValues["propertyDebt"];
          //       itemTotal -= mortgageValues["propertyDebt"];
          //     }
          //     if (mortgageValues["propertyPrimaryMortgageRepayments"]) {
          //       totals["expenseTotal"] += mortgageValues["propertyPrimaryMortgageRepayments"] * 12;
          //       //totals["expenseItemList"].push({ "sectionName": sectionName, "itemName": "Mortgage Repayments", "Id": item["Id"], "itemTotal": mortgageValues["propertyPrimaryMortgageRepayments"] * 12 });
          //       expenseItem["itemTotal"] += mortgageValues["propertyPrimaryMortgageRepayments"] * 12;
          //       itemTotal -= mortgageValues["propertyPrimaryMortgageRepayments"] * 12;
          //     }
          //   }
          //   if (utilitiesExpense) {
          //     totals["expenseTotal"] += utilitiesExpense;
          //     //totals["expenseItemList"].push({ "sectionName": sectionName, "itemName": "Utilities", "Id": item["Id"], "itemTotal": utilitiesExpense });
          //     expenseItem["itemTotal"] += utilitiesExpense;
          //     itemTotal -= utilitiesExpense;
          //   }
          // }
          // else { //if rental property
          if (!isPrimaryResidence) {
            if (mortgageValues) {
              // if (mortgageValues["propertyDebt"]) {
              //   //totals["assetTotal"] -= mortgageValues["propertyDebt"];
              //   //totals["debtItemList"].push({ "sectionName": sectionName, "itemName": "Mortgage", "Id": item["Id"], "itemTotal": mortgageValues["propertyDebt"] * 12 });
              //   debtItem["itemTotal"] += mortgageValues["propertyDebt"] * 12;
              //   itemTotal -= mortgageValues["propertyDebt"];
              // }
              if (mortgageValues["propertyNonPrimaryMortgageRepayments"]) {
                totals["incomeTotal"] -=
                  mortgageValues["propertyNonPrimaryMortgageRepayments"] *
                  12 *
                  incomeShare;
                incomeItem["itemTotal"] -=
                  mortgageValues["propertyNonPrimaryMortgageRepayments"] *
                  12 *
                  incomeShare;

                //rental properties never appear in expenses. (or any expenses associated with rental properties)
                //totals["expenseItemList"].push({ "sectionName": sectionName, "itemName": "Mortgage Repayments", "Id": item["Id"], "itemTotal": mortgageValues["propertyNonPrimaryMortgageRepayments"] * 12 });
                //expenseItem["itemTotal"] += mortgageValues["propertyNonPrimaryMortgageRepayments"] * 12;
                //itemTotal -= mortgageValues["propertyNonPrimaryMortgageRepayments"] * 12;
              }
            }
            if (utilitiesExpense) {
              totals["incomeTotal"] -= utilitiesExpense * incomeShare;
              incomeItem["itemTotal"] -= utilitiesExpense * incomeShare;
              //rental properties never appear in expenses. (or any expenses associated with rental properties)
              //totals["expenseItemList"].push({ "sectionName": sectionName, "itemName": "Utilities", "Id": item["Id"], "itemTotal": utilitiesExpense });
              //expenseItem["itemTotal"] += utilitiesExpense;
              //itemTotal -= utilitiesExpense;
            }
            if (insuranceExpense) {
              totals["incomeTotal"] -= insuranceExpense * incomeShare;
              incomeItem["itemTotal"] -= insuranceExpense * incomeShare;
            }
          }
        } catch (e) {
          let kk = 0;
        }
      }
      if (isProperty) {
        let kk = 0;
      }

      if (!isProperty) {
        if (item["propertyId"]) {
          collatedWithRentalResidence =
            propertyList && propertyList[item["propertyId"]]
              ? !propertyList[item["propertyId"]].isPrimaryResidence
              : false;
        } else {
          collatedWithRentalResidence = false;
        }
      }

      try {
        for (let field of valueFields) {
          let amount = 0;
          //scan the data for this field
          if (field["fieldid"] == null || !field["fieldid"]) {
            continue;
          }
          if (
            isNaN(
              this.currencyConvert.monetaryValueInDefaultCurrency(
                item[field["fieldid"]]
              )
            ) &&
            !isArray(item[field["fieldid"]])
          ) {
            continue;
          }
          if (!item[field["fieldid"]]) {
            continue;
          }
          if (item[field["fieldid"]] == null) {
            continue;
          }

          let valueType = field["valuetype"];
          //if it is a property and not a primary residence, we will sum all values into the assetTotal //YJ: this logic is only true for income, expenses we skip for non primary residences and assets/debts aren't affected by whether a residence is primary or rental.
          if (!isArray(item[field["fieldid"]])) {
            //for other asset formarray
            amount = this.currencyConvert.monetaryValueInDefaultCurrency(
              item[field["fieldid"]]
            );
          }
          //if it is a form array with incomes or expenses - set the amount to the sum - see other assets'
          //No amount is directly stored for the father "fieldId"

          if (!amount || amount == 0) {
            continue;
          } else {
            if (incomeShare >= 0) {
              amount = amount * incomeShare;
            }
          }
          incomeItem["incomeShare"] = incomeShare; // pass this on so we can apply it later.
          switch (valueType) {
            // log out valuetype

            case "asset":
              assetTotal += amount;
              itemTotal += amount;
              //totals["assetItemList"].push({ "sectionName": sectionName, "itemName": item["itemName"], "Id": item["Id"], "itemTotal": amount })
              assetItem["itemTotal"] += amount;
              break;
            case "debtsdebt":
              debtTotal += amount;
              itemTotal += amount;
              //totals["debtItemList"].push({ "sectionName": sectionName, "itemName": item["itemName"], "Id": item["Id"], "itemTotal": amount });
              debtItem["itemTotal"] += amount;
              break;
            case "debt":
              if (isProperty && !isPrimaryResidence) {
                //rented properties are calculated differently
                // assetTotal -= amount;
                // itemTotal -= amount;
                //totals["debtItemList"].push({ "sectionName": sectionName, "itemName": item["itemName"], "Id": item["Id"], "itemTotal": amount });
                debtItem["itemTotal"] += amount;
                //assetTotal -= amount;
                itemTotal -= amount;
                debtTotal += amount;
                // if (totals["assetItemList"].length == 0) {
                //   totals["assetItemList"].push({ "sectionName": sectionName, "itemName": item["itemName"], "Id": item["Id"], "itemTotal": 0 })
                // }
                //We should already have a row for this property. we need to deduct from the amount
                // let theRows: {}[] = totals["assetItemList"];
                // let theRow = theRows.find(row => row["Id"] == item["Id"]);
                // if (!theRow) { break; }
                // else{ theRow["itemTotal"] -= amount;}
              } else {
              console.log('valueType', valueType);

                debtTotal += amount;
                itemTotal += amount;
                //totals["debtItemList"].push({ "sectionName": sectionName, "itemName": item["itemName"], "Id": item["Id"], "itemTotal": amount });
                debtItem["itemTotal"] += amount;
              }
              break;
            case "income":
              if (!collatedWithRentalResidence) {
                incomeTotal += amount;
                //itemTotal += ammount;
                //totals["incomeItemList"].push({ "sectionName": sectionName, "itemName": item["itemName"], "Id": item["Id"], "itemTotal": amount });
                incomeItem["itemTotal"] += amount;
              }
              break;
            case "expense":
              if (!collatedWithRentalResidence) {
                if (isProperty && !isPrimaryResidence) {
                  //properties are calculated differently
                  // incomeTotal -= amount;
                  // itemTotal -= amount;
                  // if (totals["incomeItemList"].length == 0) {
                  //   totals["incomeItemList"].push({ "sectionName": sectionName, "itemName": item["itemName"], "Id": item["Id"], "itemTotal": 0 })
                  // }
                  //totals["expenseItemList"].push({ "sectionName": sectionName, "itemName": item["itemName"], "Id": item["Id"], "itemTotal": amount })
                  expenseItem["itemTotal"] += amount;
                  let theRows: {}[] = totals["incomeItemList"];
                  let theRow = theRows.find((row) => row["Id"] == item["Id"]);
                  incomeTotal -= amount;
                  incomeItem["itemTotal"] -= amount;
                  //itemTotal -= ammount;
                  try {
                    if (!theRow) {
                      break;
                    } else {
                      theRow["itemTotal"] -= amount;
                    }
                  } catch (e) {
                    //let kk = 0;
                  }
                } else {
                  expenseTotal += amount;
                  if (isProperty) {
                    //itemTotal -= ammount;
                  } else {
                    //itemTotal += ammount;
                  }
                  //totals["expenseItemList"].push({ "sectionName": sectionName, "itemName": item["itemName"], "Id": item["Id"], "itemTotal": amount })
                  expenseItem["itemTotal"] += amount;
                }
              }
              break;
            case "incomeMonthly":
              if (!collatedWithRentalResidence) {
                incomeTotal += amount * 12;
                //itemTotal += ammount * 12;
                //totals["incomeItemList"].push({ "itemName": item["itemName"], "Id": item["Id"], "itemTotal": amount * 12 })
                incomeItem["itemTotal"] += amount * 12;
              }
              break;
            // case "expenseExpenseMonthly":
            // if (isProperty && !isPrimaryResidence) { //properties are calculated differently
            //   //for rented properties we deduct expense from income
            //   incomeTotal -= amount * 12;
            //   itemTotal -= amount * 12;
            //   //here we find the row in the incomeItemList and deduct the expense
            //   let theRows: {}[] = totals["incomeItemList"];
            //   let theRow = theRows.find(row => row["Id"] == item["Id"]);
            //   if (!theRow) { break; }
            //   else { theRow["amount"] -= amount; }
            // }
            // else {
            //   expenseTotal += amount * 12;
            //   if (isProperty) {
            //     itemTotal -= amount * 12;
            //   }
            //   else {
            //     itemTotal += amount * 12;
            //   }
            //   totals["expenseItemList"].push({ "sectionName": sectionName, "itemName": item["itemName"], "Id": item["Id"], "itemTotal": amount * 12 })
            // }
            // break;
            case "expenseMonthly":
              if (!collatedWithRentalResidence) {
                if (isProperty && !isPrimaryResidence) {
                  //properties are calculated differently
                  //for rented properties we deduct expense from income
                  incomeTotal -= amount * 12;
                  incomeItem["itemTotal"] -= amount * 12;

                  //itemTotal -= ammount * 12;
                  //here we find the row in the incomeItemList and deduct the expense
                  let theRows: {}[] = totals["incomeItemList"];
                  let theRow = theRows.find((row) => row["Id"] == item["Id"]);
                  if (!theRow) {
                    break;
                  } else {
                    theRow["amount"] -= amount;
                  }
                } else {
                  if (sectionName == "mortgage") {
                    break;
                  } //for mortgages, just sum the current debt
                  expenseTotal += amount * 12;
                  if (isProperty) {
                    //itemTotal -= ammount * 12;
                  } else {
                    //itemTotal += ammount * 12;
                  }
                  //totals["expenseItemList"].push({ "sectionName": sectionName, "itemName": item["itemName"], "Id": item["Id"], "itemTotal": amount * 12 })
                  expenseItem["itemTotal"] += amount * 12;
                }
              }
              break;
            case "expenseExpenseMonthlyOrYearly":
              if (!collatedWithRentalResidence) {
                let monthlyYearlyField2 = "";
                if (field["valueMonthOrYearFieldId"]) {
                  monthlyYearlyField2 = field["valueMonthOrYearFieldId"];
                } else {
                  //it is general expenses and we need to build the name of the per month/per year field
                  monthlyYearlyField2 = field["fieldid"] + "Freq";
                }
                switch (item[monthlyYearlyField2]) {
                  case "Per Month":
                    expenseTotal += amount * 12;
                    //itemTotal += ammount * 12;
                    //totals["expenseItemList"].push({ "sectionName": sectionName, "itemName": item["itemName"], "Id": item["Id"], "itemTotal": amount * 12 })
                    expenseItem["itemTotal"] += amount * 12;
                    break;
                  case "Per Year":
                    expenseTotal += amount;
                    //itemTotal += ammount;
                    //totals["expenseItemList"].push({ "sectionName": sectionName, "itemName": item["itemName"], "Id": item["Id"], "itemTotal": amount })
                    expenseItem["itemTotal"] += amount;
                    break;
                }
              }
              break;
            case "sharePrice":
              //get the number of shares
              let shareCount = item["shareCount"];
              assetTotal += (amount * shareCount) / 100; //the original is in pence
              itemTotal += (amount * shareCount) / 100;
              //totals["assetItemList"].push({ "sectionName": sectionName, "itemName": item["itemName"], "Id": item["Id"], "itemTotal": amount * shareCount })
              assetItem["itemTotal"] += (amount * shareCount) / 100;

              break;
            case "expenseMonthlyOrYearly":
              if (!collatedWithRentalResidence) {
                let monthlyYearlyField = "";
                if (field["valueMonthOrYearFieldId"]) {
                  monthlyYearlyField = field["valueMonthOrYearFieldId"];
                } else {
                  //it is general expenses and we need to build the name of the per month/per year field
                  monthlyYearlyField = field["fieldid"] + "Freq";
                }
                switch (item[monthlyYearlyField]) {
                  case "Per Month":
                    expenseTotal += amount * 12;
                    //itemTotal -= ammount * 12;
                    //totals["expenseItemList"].push({ "sectionName": sectionName, "itemName": item["itemName"], "Id": item["Id"], "itemTotal": amount * 12 })
                    expenseItem["itemTotal"] += amount * 12;
                    break;
                  case "Per Year":
                    expenseTotal += amount;
                    //itemTotal -= ammount;
                    //totals["expenseItemList"].push({ "sectionName": sectionName, "itemName": item["itemName"], "Id": item["Id"], "itemTotal": amount })
                    expenseItem["itemTotal"] += amount;
                    break;
                }
              }
              break;
            case "":
              break;
          }
        }
        if (assetItem["itemTotal"] > 0) {
          totals["assetItemList"].push(assetItem);
        }
        if (debtItem["itemTotal"] > 0) {
          totals["debtItemList"].push(debtItem);
        }
        if (
          incomeItem["itemTotal"] >
          0 /*|| (incomeItem["itemTotal"] != 0 && isProperty && !isPrimaryResidence)*/
        ) {
          totals["incomeItemList"].push(incomeItem);
        }
        if (incomeItem["itemTotal"] < 0 && isProperty && !isPrimaryResidence) {
          totals["incomeItemList"].push(incomeItem);
        }
        if (expenseItem["itemTotal"] > 0) {
          totals["expenseItemList"].push(expenseItem);
        }
      } catch (e) {
        let kk = 0;
      }
      // if (isProperty) {
      //   let kk = 0;
      mySectionItemList.push({
        sectionName: sectionName,
        itemName: item["itemName"],
        Id: item["Id"],
        itemTotal: itemTotal,
      });
      // }
      // else {
      //   mySectionItemList.push({ "sectionName": sectionName, "itemName": item["itemName"], "Id": item["Id"], "itemTotal": itemTotal });
      // }
      sectionTotal += itemTotal;
    }
    var kkk: {}[] = [];
    //kkk = mySectionItemList.sort((a,b)=>a["itemTotal"]-b["itemTotal"]);
    totals["assetTotal"] += assetTotal;
    totals["debtTotal"] += debtTotal;
    totals["incomeTotal"] += incomeTotal;
    totals["expenseTotal"] += expenseTotal;
    totals["itemList"] = mySectionItemList;
    totals["sectionTotal"] = sectionTotal;

    return totals;
  }

  async addInsuranceToProperty(insuranceId, propertyId, clientId) {
    //when a user adds a property to an umi, we will add the isurance to the property
    //Check if the umi is already connected to the property
    let myProperty = await this.getItem(propertyId, "property", clientId);
    if (
      !myProperty["propertyInsurances"] ||
      !myProperty["propertyInsurances"].includes(insuranceId)
    ) {
      if (!myProperty["propertyInsurances"]) {
        myProperty["propertyInsurances"] = [];
        myProperty["propertyHasInsurances"] = true;
      }
      myProperty["propertyInsurances"].push(insuranceId);
      await this.updateItem(myProperty, "property", clientId);
      return true;
    }
    return false;
  }

  async removeInsuranceFromProperty(InsuranceId: string, propertyId, clientId) {
    //when a user removes a property from an umi, or replaces it with another property, we will remove the isurance from the property
    //Check if the umi is already connected to the property
    let myProperty = await this.getItem(propertyId, "property", clientId);
    if (
      myProperty["propertyInsurance"] &&
      myProperty["propertyInsurance"].includes(InsuranceId)
    ) {
      let myInsurance: string[] = myProperty["propertyInsurance"];
      if (myInsurance.length == 1) {
        delete myProperty["propertyInsurance"];
        myProperty["propertyHasInsurances"] = false;
      } else {
        myInsurance.splice(myInsurance.indexOf(InsuranceId), 1);
        myProperty["propertyInsurance"] = myInsurance;
      }
      await this.updateItem(myProperty, "property", clientId);

      return true;
    }
    return false;
  }

  async addMortgageToProperty(mortgageId, propertyId, clientId) {
    //when a user adds a property to an umi, we will add the isurance to the property
    //Check if the umi is already connected to the property
    let myProperty = await this.getItem(propertyId, "property", clientId);
    if (
      !myProperty["propertyMortgages"] ||
      !myProperty["propertyMortgages"].includes(mortgageId)
    ) {
      if (!myProperty["propertyMortgages"]) {
        myProperty["propertyMortgages"] = [];
        myProperty["propertyMortgaged"] = true;
      }
      myProperty["propertyMortgages"].push(mortgageId);
      await this.updateItem(myProperty, "property", clientId);
      return true;
    }
    return false;
  }

  async removeMortgageFromProperty(mortgageId: string, propertyId, clientId) {
    //when a user removes a property from an umi, or replaces it with another property, we will remove the isurance from the property
    //Check if the umi is already connected to the property
    let myProperty = await this.getItem(propertyId, "property", clientId);
    if (
      myProperty["propertyMortgages"] &&
      myProperty["propertyMortgages"].includes(mortgageId)
    ) {
      let myMortgages: string[] = myProperty["propertyMortgages"];
      if (myMortgages.length == 1) {
        delete myProperty["propertyMortgages"];
        myProperty["propertyMortgaged"] = false;
      } else {
        myMortgages.splice(myMortgages.indexOf(mortgageId), 1);
        myProperty["propertyMortgages"] = myMortgages;
      }
      await this.updateItem(myProperty, "property", clientId);
      return true;
    }
    return false;
  }

  async addUtilityToProperty(utilityId, propertyId, clientId) {
    //when a user adds a property to an umi, we will add the isurance to the property
    //Check if the umi is already connected to the property
    let myProperty = await this.getItem(propertyId, "property", clientId);
    if (
      !myProperty["propertyUtilities"] ||
      !myProperty["propertyUtilities"].includes(utilityId)
    ) {
      if (!myProperty["propertyUtilities"]) {
        myProperty["propertyUtilities"] = [];
        myProperty["propertyHasUtilities"] = true;
      }
      myProperty["propertyUtilities"].push(utilityId);
      await this.updateItem(myProperty, "property", clientId);

      return true;
    }
    return false;
  }

  async removeUtilityFromProperty(utilityId: string, propertyId, clientId) {
    //when a user removes a property from an umi, or replaces it with another property, we will remove the isurance from the property
    //TODO - check if there are no other insurances, and mark "no" for has utilities.
    //Check if the umi is already connected to the property
    let myProperty = await this.getItem(propertyId, "property", clientId);
    if (
      myProperty["propertyUtilities"] &&
      myProperty["propertyUtilities"].includes(utilityId)
    ) {
      let myUtilites: string[] = myProperty["propertyUtilities"];
      if (myUtilites.length == 1) {
        delete myProperty["propertyUtilities"];
        myProperty["propertyHasUtilities"] = false;
      } else {
        myUtilites.splice(myUtilites.indexOf(utilityId), 1);
        myProperty["propertyUtilities"] = myUtilites;
      }
      await this.updateItem(myProperty, "property", clientId);
      return true;
    }
    return false;
  }

  async addPropertyToUtilitiesMortgagesInsurance(formValue, clientId) {
    //scan all UMIs of the user if in property list - set propertyId if different
    //If not in list and has current property Id - remove propertyId

    ///Utilities///
    let myUtilities = [];
    if (
      formValue["propertyUtilities"] &&
      formValue["propertyUtilities"].length > 0
    ) {
      myUtilities = formValue["propertyUtilities"];
    }
    let utilities: {}[] = [];
    utilities = await this.getSection("utilities", clientId);
    for (let item of utilities) {
      if (
        item["propertyId"] == formValue["Id"] &&
        !myUtilities.includes(item["Id"])
      ) {
        //reset if removed
        item["propertyId"] = "";
        item["utilityPropertyLink"] = false;
        await this.updateItem(item, "utilities", clientId);
      } else {
        if (myUtilities.length > 0) {
          if (item["propertyId"] && item["propertyId"].length > 0) {
            //change it if changed
            if (
              myUtilities.includes(item["Id"]) &&
              item["propertyId"] != formValue["Id"]
            ) {
              item["propertyId"] = formValue["Id"];
              item["utilityPropertyLink"] = true;
              await this.updateItem(item, "utilities", clientId);
            }
          } else {
            //fill it if chosen
            if (myUtilities.includes(item["Id"])) {
              item["propertyId"] = formValue["Id"];
              item["utilityPropertyLink"] = true;
              await this.updateItem(item, "utilities", clientId);
            }
          }
        }
      }
    }

    ////Mortgages
    let myMortgages = [];
    if (
      formValue["propertyMortgages"] &&
      formValue["propertyMortgages"].length > 0
    ) {
      myMortgages = formValue["propertyMortgages"];
    }
    let mortgages: {}[] = [];
    mortgages = await this.getSection("mortgages", clientId);
    for (let item of mortgages) {
      if (
        item["propertyId"] == formValue["Id"] &&
        !myMortgages.includes(item["Id"])
      ) {
        //reset if removed
        item["propertyId"] = "";
        await this.updateItem(item, "mortgages", clientId);
      } else {
        if (myMortgages.length > 0) {
          if (item["propertyId"] && item["propertyId"].length > 0) {
            //change it if changed:
            if (
              myMortgages.includes(item["Id"]) &&
              item["propertyId"] != formValue["Id"]
            ) {
              item["propertyId"] = formValue["Id"];
              await this.updateItem(item, "mortgages", clientId);
            }
          } else {
            //fill it if chosen
            if (myMortgages.includes(item["Id"])) {
              item["propertyId"] = formValue["Id"];
              await this.updateItem(item, "mortgages", clientId);
            }
          }
        }
      }
    }

    ////Insurance
    let myInsurance = [];
    if (
      formValue["propertyInsurances"] &&
      formValue["propertyInsurances"].length > 0
    ) {
      myInsurance = formValue["propertyInsurances"];
    }
    let insurance: {}[] = [];
    insurance = await this.getSection("insurance", clientId);
    for (let item of insurance) {
      if (
        item["propertyId"] == formValue["Id"] &&
        !myInsurance.includes(item["Id"])
      ) {
        //reset if removed
        item["propertyId"] = "";
        await this.updateItem(item, "insurance", clientId);
      } else {
        if (myInsurance.length > 0) {
          if (item["propertyId"] && item["propertyId"].length > 0) {
            //change it if changed:
            if (
              myInsurance.includes(item["Id"]) &&
              item["propertyId"] != formValue["Id"]
            ) {
              item["propertyId"] = formValue["Id"];
              await this.updateItem(item, "insurance", clientId);
            }
          } else {
            //fill it if chosen
            if (myInsurance.includes(item["Id"])) {
              item["propertyId"] = formValue["Id"];
              await this.updateItem(item, "insurance", clientId);
            }
          }
        }
      }
    }
  }

  public async chargeBeeCheckout(params) {
    return await this.retrieveData("post", "/api/cbcheckout", params);
  }
  public async chargeBeePortal(params) {
    return await this.retrieveData("post", "/api/cbportal", {});
  }

  public async chargeBeeSaveSubscriptionId(subscriptionId) {
    let data = await this.retrieveData("post", "/api/cbSaveSubscriptionId", {
      subscriptionId: subscriptionId,
    });
    if (data.zptoken) {
      //update the token
      this.token = data.zptoken;
      localStorage.setItem("token", data.zptoken);
    }
    return data;
  }

  public async requestPasswordReset(email) {
    return await this.retrieveData("post", "/api/requestPasswordReset", {
      email: email,
    });
  }
  public async passwordReset(activationCode, password, confirmPassword) {
    return await this.retrieveData("post", "/api/resetPassword", {
      activationCode: activationCode,
      password: password,
      confirmPassword: confirmPassword,
    });
  }

  async deleteFile(internalFileName, itemId) {
    let deleteTheFile = await this.retrieveData("post", "/api/fileDelete", {
      internalFileName: internalFileName,
      itemId: itemId,
    });
    if (deleteTheFile.success) {
      return true;
    }
    return false;
  }

  //just hand this a single file from an <input type="file">'s files array.
  public async uploadFile(file, itemId, filename?) {
    let data;
    try {
      let formData = new FormData();
      formData.append("file", file, filename || file.name);
      data = await this.httpClient
        .post(this.apiUrl + "/api/file", formData, {
          headers: { "Item-Id": itemId, Authorization: this.token },
          reportProgress: true,
          observe: "events",
        })
        .toPromise();
    } catch (err2) {
      this.identifyAndHandleHTTPErrorStates(err2);
      console.log(err2);
      return err2.error;
    }
    return data && data.body ? data.body : data;
  }

  // this returns a list of all the files associated with the item (to which belongs the clientId) -- if no clientId is provided it will retrieve the listings of all the files of the logged-in user.
  public async retrieveFileNames(itemId) {
    let params = new HttpParams();
    if (itemId) {
      params = new HttpParams().set("itemId", itemId);
    }
    return await this.retrieveData("get", "/api/files", params, true);
  }

  //to retrieve a file by name once you know what the name is:

  public async getLogoUrl(refCode?) {
    if (!refCode) {
      let myUser = await this.getUser();
      refCode = myUser.refCode;
    }
    if (refCode) {
      return this.apiUrl + "/api/logo?refCode=" + refCode;
    }
  }

  // To retrieve ALL the suggested next steps
  public async retrieveSuggestedNextSteps() {
    let nextSteps = await this.retrieveData("get", "/api/nextsteps");
    if (nextSteps.skipped) {
      nextSteps.results = nextSteps.results.filter(
        (step) => !Object.keys(nextSteps.skipped).includes(step._id)
      );
    }
    return nextSteps;
  }
  public async skipNextStepSuggestion(suggestNextStepId) {
    return await this.retrieveData("post", "/api/skipnextstep", {
      suggestionId: suggestNextStepId,
    });
  }
  // To retrieve ALL the suggested next steps
  public async getSubscriptionStatus() {
    return await this.retrieveData("get", "/api/validSubscription");
  }
  public async requestMFACode() {
    return await this.retrieveData("get", "/api/mfa");
  }
  public async confirmMFACode(code) {
    let data = await this.retrieveData("post", "/api/mfa", { mfa_code: code });
    if (data.success && data.zptoken) {
      this.token = data.zptoken;
      localStorage.setItem("token", data.zptoken);
    }
    return data;
  }

  public async sendEmail(email, subject, template, info) {
    return await this.retrieveData("post", "/api/sendCustomMail", {
      email: email,
      subject: subject,
      template: template,
      info: info,
    });
  }

  public async autoInviteProfessionalDelegate(refCode?: string) {
    let myUser = await this.getUser();
    if (!refCode) {
      refCode = myUser.refCode;
    }
    let info = await this.retrieveValidRefCode(refCode);
    if (info.email) {
      let timestamp = Date.now().toString();
      let delegate = {
        assetsPermission: "never",
        clientId: myUser.Id,
        dailyLifePermission: "never",
        digitalLifePermission: "never",
        debtsPermission: "never",
        delegateId: "",
        delegateRelation: "Professional Advisor",
        delegatesExplanations: "",
        email: info.email,
        emailConfirm: info.email,
        firstName: info.firstName,
        invitation: "automatically added delegate",
        lastName: info.lastName,
        lastUpdate: timestamp,
        lastUpdateBy: myUser.Id,
        telephone: "",
        upToDateExpire: timestamp,
        wishesPermission: "never",
      };
      let res = await this.addItem(JSON.stringify(delegate), "delegates");
      if (res.success) {
        this.router.navigate(["/dynamicedit/delegate-edit/" + res.itemId]);
        return true;
      }
    }
  }

  // List of Licenses Professional Manager
  public async getProfessionalAccounts() {
    let accounts = await this.retrieveData("get", "/api/licenses");
    if (accounts.professionalAccounts) {
      return accounts.professionalAccounts;
    } else {
      return [];
    }
  }

  public async refreshToken() {
    let data = await this.retrieveData("post", "/api/refreshtoken", {});
    if (data.success && data.zptoken) {
      this.token = data.zptoken;
      localStorage.setItem("token", data.zptoken);
    }
    return data;
  }

  public async getAvatar(clientId?) {
    let fileToken = await this.generateFileAuth();
    let avatar =
      this.apiUrl + "/api/avatar?userId=" + clientId + "&auth=" + fileToken;
    return avatar;
  }

  public async getDynamicPricingFromChargeBee(refCode?) {
    let data = await this.retrieveData(
      "get",
      "/api/cb/getPlan",
      new HttpParams().set("code", refCode)
    );
    if (data) {
      console.log(data);
      return data;
    }
  }

  public async getProfessionalResource() {
    let result = await this.retrieveData("get", "/api/professionalResource");
    if (result && result.success) {
      return result.items;
    } else {
      return [];
    }
  }

  public async createPlanToDelegate() {
    let data = await this.retrieveData("post", "/api/upgradeDelegate", {});
    if (data.success && data.zptoken) {
      this.token = data.zptoken;
      localStorage.setItem("token", data.zptoken);
    }
    return data;
  }

  public async generateFileAuth() {
    let data = await this.retrieveData("get", "/api/fileAuth");
    if (data.success) {
      return data.fileAuthToken;
    }
  }

  public async deleteUserAccount() {
    let data = await this.retrieveData("post", "/api/cancel", {});
    if (data || data.success) {
      return data;
    }
  }

  public async getAnalyticsStats() {
    let data = await this.retrieveData("get", "/api/stats");
    return data;
  }



  ifOwnsThisItem(planItem, ownerName) {
    if (planItem.newJointOwners) {
      for (const item of planItem.newJointOwners) {
        if (item.owner.first + item.owner.last === ownerName) {
          return true;
        }
      }
    }
    return false
  }

  public async updateItemsOwnerName(plan, newOwner, oldOwner) {
    console.log('updateItemsOwnerName(), newOwner - ', newOwner)
    //let ownerArrayWithItems = [];
    for (let itemType in plan) {
      for (let item of plan[itemType]) {
        // console.log('item ! - ', item)
        if (item.newJointOwners) {
          for (const idx in item.newJointOwners) {
            let owner = item.newJointOwners[idx];
            if (JSON.stringify(owner.owner) === JSON.stringify(oldOwner)) {
              owner.owner = newOwner;
              await this.updateItem(item,itemType);
            }
          }
        }
      }
    }
  }


  public findItemsOwnedByOwner(plan, owner) {
    let ownerArrayWithItems = [];
    for (let itemType in plan) {
      for (let item of plan[itemType]) {
        if (this.ifOwnsThisItem(item, owner.first + owner.last)) {
          ownerArrayWithItems.push(item.itemName + " (" + itemType + ")");
        }
      }
    }
    return ownerArrayWithItems;
  }

  public checkIfSharedPlanIsUpgraded(sharedPlansCategories) {
    console.log(sharedPlansCategories)
    if (sharedPlansCategories) {
      for (let itemType in sharedPlansCategories) {
        for (let item of sharedPlansCategories[itemType]) {
          console.log('old owner item -', item)
          if (!item.newJointOwners) {
            console.log('There aren\'t new owners here.')
            return false
          } else {
            return true
          }
        }
      }
    }
  }
  //for now i think we aren't using this function -yitz..
  //main reason is handling sharedPlans can create issues.
  async updatePlanIfNotCurrent(user, plan) {
    if (!user.planVersion || user.planVersion < 2.0) {
      for (let itemType in plan) {
        let newItemList = [];
        for(let item of plan[itemType]){
          try {
            let baseType = undefined;
            for (let i = 0; i < plantree.length; i++) {
              let sections = plantree[i].sectionObjects;
              if (sections) {
                for (let j = 0; j < sections.length; j++) {
                  if (sections[j].section === itemType) {
                    baseType = sections[j].baseName;
                  }
                }
              }
            }
            if(!baseType){
              //log it
              console.log('baseType not found for - ', itemType);
            }
            const results = await this.convertToNewJointOwners(item, itemType, baseType, user);
            user = results.user; // to save user state when we add new owners to user.jointOwners;
            newItemList.push(results.item);
          }catch(err){
            //if for some reason our attempts to modify the item failed, we will just add it to the new list without any changes.
            newItemList.push(item);
            //print err
            console.log('error while updating plan - ', err);

          }
        }
        plan[itemType] = newItemList;
      }
      user.planVersion = 2.0;
      this.updateUser(user);
    }

    return plan;
  }
  public async convertToNewJointOwners(item, itemType, baseType, user) {
    if (!item.newJointOwners) {
      if (item.jointOwners) {
        var newJointOwners = [];
        item.jointOwners.forEach((oldOwner) => {
          var newOwner = {};
          const name = oldOwner.Owner.split(' ');


          if (oldOwner.Owner.toLowerCase().includes(user.firstName.toLowerCase() + " " + user.lastName.toLowerCase())) {
            newOwner['owner'] = {
              first: user.firstName,
              last: user.lastName,
              relationship: "Plan holder"
            }
          } else {
            newOwner['owner'] = {first: name.shift(), last: name.join(' '), relationship: ""};
          }
          // newOwner['owner'] = { first: name.shift(), last: name.join(' '), relationship: "" };
          // if (oldOwner.Owner.startsWith(user.firstName) && oldOwner.Owner.endsWith(user.lastName)) {
          //   newOwner['owner'].relationship = 'Plan holder';
          // }

          newOwner['share'] = oldOwner.Percentage;
          user = this.addNewOwnerToJointOwnersListIfTheyDontExistAlready(newOwner['owner'], user);
          newJointOwners.push(newOwner);
        });
        item.newJointOwners = newJointOwners;
        delete item.jointOwners
        this.updateItem(item, itemType, user.clientId);
      }
      else {
        let myFormTemplate =
          await this.formTemplateService.getFormTemplateAsync(
            baseType + "-edit"
          );
          console.log('3 itemType - ', itemType)
          console.log('myFormTemplate - ', myFormTemplate)
        //find the newJointOwners field in the form template and if it exists add newJointOwners to the item.
        if (myFormTemplate && myFormTemplate.fields) {
          for (let field of myFormTemplate.fields) {
            if (field.fieldid === "newJointOwners") {
              item.newJointOwners = [
                {
                  owner: {
                    first: user.firstName,
                    last: user.lastName,
                    relationship: "Plan holder",
                  },
                  share: 100,
                },
              ];
              this.updateItem(item, itemType, user.clientId);
            }
          }
        }
      }
    }
    return {user: user, item: item};
  }
  public addNewOwnerToJointOwnersListIfTheyDontExistAlready(owner, user) {
    if (user && !user.jointOwners) {
      user.jointOwners = [];
    }
    if (!user.jointOwners.find(jOwner => jOwner.first + jOwner.last == owner.first + owner.last)) {
      user.jointOwners.push(owner);
    }
    return user;
  }

  public displaySharedPlansOwner(ownersHashmap) {
    console.log('ownersHashmap - ', ownersHashmap)
    this.ownersHashmap = ownersHashmap
    console.log('displaySharedPlansOwner() - ', this.ownersHashmap)
    return this.ownersHashmap;
  }

  public getSharedPlansSelectedOwners(sharedPlanCategories) {
    if (sharedPlanCategories.length) {
      for (let itemType in sharedPlanCategories) {
        for (let item of sharedPlanCategories[itemType]) {
          if (item.newJointOwners) {
            for (let owner of item.newJointOwners) {
              this.ownersSelectedHashmap[owner.owner.first + owner.owner.last] = owner.owner;
              return this.ownersSelectedHashmap;
            }
          }
        }
      }
    }
  }

  public async getFeedClients() {
    let data = await this.retrieveData("get", "/api/clientFeed");
    console.log('clientFeed - ', data)
    return data
  }

  public async getProfessionalInviteTemplate() {
    let data = await this.retrieveData("get", "/api/professionalInviteTemplate");
    console.log('professionalTemplate - ', data);
    return data;
  }

  public async getProfessionalInviteTemplateForModal(mode: string) {
    let data = await this.retrieveData("get", `/api/professionalInviteTemplate?mode=${mode}`);
    console.log('professionalTemplate - ', data);
    return data;
  }

  public async sendInvites(emailToSend: any) {
    let params = emailToSend;
    let data = await this.retrieveData("post", "/api/professionalSendInvites", params);
    console.log('data: ', data)
    return data;
  }

  public async getProfessionalInviteTemplatePlaceholders() {
    let data = await this.retrieveData("get", "/api/professionalInviteTemplatePlaceholders");
    console.log("professionalInviteTemplatePlaceholders: ", data);
    return data;
  }
}
